import React, { Fragment, useEffect, useRef, useState } from "react";
import { Row, Col, Card, Divider, Button, Input, Modal, Tabs, Select, Drawer, message, Checkbox, Form, Spin, Table, Alert, Typography, DatePicker } from "antd";
import {
  SearchOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  CloseOutlined,
  SyncOutlined,
  LoadingOutlined,
  EyeOutlined,
  UserOutlined,
  CalendarOutlined,
  PhoneOutlined,
  WalletOutlined,
  EditOutlined,
  CreditCardOutlined,
  CheckCircleFilled,
  GiftOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { htmlPrint } from "../../../../lib/printer/htmlPrinter";
import Close from "../../../../assets/images/close-x.svg";
import User from "../../../../assets/images/User.svg";
import SearchIcon from "../../../../assets/images/searchIcon.svg";
import db from "../../../../database";
import { Scrollbars } from "react-custom-scrollbars";
import { useTranslation } from "react-i18next";
import userTieIcon from "../../../../assets/images/userTieIcon.svg";
import Keyboard from "react-simple-keyboard";
import _ from "lodash";
import "../styles.css";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import wallet from "../../../../assets/images/wallet.svg";
import cash from "../../../../assets/images/cash.svg";
import credit from "../../../../assets/images/creditIcon.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import cardType from "../../../../assets/images/cardType.svg";
import UPI from "../../../../assets/images/upiIcon.svg";
import Credit from "../../../../assets/images/creditCardIcon.svg";
import ticSelect from "../../../../assets/images/tic.png";
import Loyality from "../../../../assets/images/loyalty.svg";
import Gift from "../../../../assets/images/giftIcon.svg";
import giftVoucher from "../../../../assets/images/giftVoucher.svg";
import creditNote from "../../../../assets/images/creditNote.svg";
import CWHCPrint from "../../../../lib/printer/CWHardwareController";
import CWPoleDisplay from "../../../../lib/printer/CWPoleDisplay";
import PoleDisplay from "../../../../lib/printer/poleDisplay";
import DeleteProduct from "../../../../assets/images/delete1.svg";
import { upsertWalletTransactionService, verifyWalletRedemption, validOtp, checkGiftCard, upsertGiftCardTransaction, getGiftCardData } from "../../../../services";
import data from "../../../../constants/retailPos.json";
import messages from "../../../../errors/messages.en-IN.json";
import { useWindowDimensions } from "../../../../lib/useViewport";

const PointOfSuperMarketModals = (props) => {
  const { t } = useTranslation();
  const {
    amount,
    cart,
    setCart,
    openSalesRep,
    setOpenSalesRep,
    selectedProductInCart,
    isStockModal,
    setIsStockModal,
    addProduct,
    handleCartTotalClick,
    tempCart,
    setTempCart,
    deleteCart,
    deleteProduct,
    posConfig,
    // open,
    // setOpen,
    keyboardType,
    setKeyboardType,
    // salesRepRef,
    salesRepValue,
    setSalesRepValue,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    selectedSaleTypeData,
    showPayments,
    setShowPayments,
    setShowPaymentMethods,
    setStartIndex,
    processOrder,
    upsertPOSLog,
    documentTypes,
    searchInputRef,
    showCustomerWallet,
    setShowCustomerWallet,
    customersData,
    setCustomersData,
    currenciesData,
    setCurrenciesData,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    handleCashPayment,
    showConfirm,
    handleAmount,
    requestPayment,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    setIsCardPaymentFlag,
    setOverPayedAmount,
    setAmount,
    paymentModalInputRef,
    filteredPaymentMethods,
    isShowingAll,
    showMoreItems,
    showPreviousItems,
    selectedCustomer,
    setSelectedCustomer,
    handleDeletePayment,
    setTillLink,
    tillLink,
    fetchWalletData,
    isWalletFlag,
    setIswalletFlag,
    isNewGiftCardFlag,
    setIsNewGiftCardFlag,
    setIsRefundWalletOpen,
    isRefundWalletOpen,
    isBankTransferOpen,
    setIsBankTransferOpen,
    realPrice,
    setRealPrice,
    PaymentMethods,
    getFilteredPaymentMethods,
    setDisplayCustomerSearch,
    isRefundCustomerEdit,
    setIsRefundCustomerEdit,
    pendingRefundCustomer,
    displayCustomerSearch,
    showReturnOptions,
    setShowReturnOptions,
    setLoading,
    setIsPurchaseReturn,
    setStartRowData,
    setIsInputFocused,
    addSelectedReturnProductsToCart,
    selectedReturnType,
    setSelectedReturnType,
    tillDataPaymentMethods,
    handlePayment,
    setCardPaymnetError,
    setShowCardPaymnteModal,
    isOnline,
    setNumb,
    setPaymentType,
    filterDrawer,
    setFilterDrawer,
    financialDocs,
    setFinancialDocs,
    financialDocument,
    setFinancialDocument,
    compressImage,
    financialForm,
    financialDocUploaded,
    setFinancialDocUploaded,
    isValidAmount,
    bankTransferContext,
    setBankTransferContext,
    selectedReturnOrder,
    currentCardInput,
    setCurrentCardInput,
    enterTotalQtyForWallet,
    currentCashInput,
    setCurrentCashInput,
    currentUPIInput,
    setCurrentUPIInput,
    dynamicPaymentInput,
    setDynamicPaymentInput,
    topupAmount,
    setTopupAmount,
    cashTendered,
    setCashTendered,
    matchedPayments,
    isProcessingTopup,
    setIsProcessingTopup,
    autoFillEnterAmount,
    showRefundModal,
    setShowRefundModal,
    handleWalletRefundComplete,
    handleWalletTopUp,
    currenciesList,
    showTopupModal,
    setShowTopupModal,
    showCardAmountInput,
    setShowCardAmountInput,
    cardPaymentForm,
    showGiftCardTopup,
    setShowGiftCardTopup,
    handleEnterTopup,
    giftCardTopupAmount,
    setGiftCardTopupAmount,
    giftCardTopupPaymentMethod,
    setGiftCardTopupPaymentMethod,
    giftCardTopupCashInput,
    setGiftCardTopupCashInput,
    giftCardTopupCardInput,
    setGiftCardTopupCardInput,
    giftCardTopupUPIInput,
    setGiftCardTopupUPIInput,
    giftCardGenericInput,
    setGiftCardGenericInput,
    currentPaymentInput,
    giftCardTotalPaid,
    currSymbol,
    currSymbolRight,
    giftCardAutoFillAmount,
    finalizeGiftCardTopup,
    giftCardMatchedPayments,
    giftCardNumber,
    setGiftCardNumber,
    giftCardPin,
    setGiftCardPin,
    resetGiftCardTopup,
    handleCheckGiftCardBalance,
    giftCardTopupPaymentPage,
    setGiftCardTopupPaymentPage,
    giftCardTopupFocusedField,
    setGiftCardTopupFocusedField,
    giftCardTopupDenomKeyboard,
    setGiftCardTopupDenomKeyboard,
    giftCardTopupShowCardAmountInput,
    setGiftCardTopupShowCardAmountInput,
    giftCardTopupCardForm,
    isCheckingBalance,
    setIsCheckingBalance,
    rawGiftCardPayments,
    giftCardBalance,
    setGiftCardBalance,
    handleGiftCardTopupAmountChange,
    deleteReceipt,
  } = props;
  const { Text, Title } = Typography;
  const { Option } = Select;
  const [inputFocused, setInputFocused] = useState("");
  const authorizationRef = useRef(null);
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const [inputFields, setInputFields] = useState({});
  const [salesRepData, setSalesRepData] = useState([]);
  const [selectedSalesRep, setSelectedSalesRep] = useState({});
  const [itemWeights, setItemWeights] = useState(() => {
    const initialWeights = {};
    cart?.items.forEach((item) => {
      initialWeights[item.lineId] = item.availableQty;
    });
    return initialWeights;
  });
  const inputRefs = useRef([]);
  const salesRepRef = useRef(null);
  const keyboardRef = useRef(null);
  const topupInputRef = useRef(null);
  const cashInputRef = useRef(null);
  const cardInputRef = useRef(null);
  const upiInputRef = useRef(null);
  const { width } = useWindowDimensions();
  //const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const [open, setOpen] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [focusedInputField, setFocusedInputField] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [currentRecord, setCurrentRecord] = useState(null);
  const showVirtualKeyboard = posConfig?.showKeyboard === "Y" ? true : false;
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const [customerSearchValue, setCustomerSearchValue] = useState("");
  const [showTransactionsModal, setShowTransactionsModal] = useState(false);
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y" ? true : false;
  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision;
  const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
  const refundCustomerLS = localStorage.getItem("refundReturnCustomerId");
  const refundCustomer = refundCustomerLS ? JSON.parse(refundCustomerLS) : null;
  const [showWalletOtpModal, setShowWalletOtpModal] = useState(false);
  const [walletOtp, setWalletOtp] = useState(Array(6).fill(""));
  const [walletOtpError, setWalletOtpError] = useState(false);
  const [walletOtpAmount, setWalletOtpAmount] = useState(null);
  const walletOtpInputsRef = useRef([]);
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));
  const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [redeemAmount, setRedeemAmount] = useState(() => {
    return !isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00";
  });
  const [walletForm] = Form.useForm();
  const [paymentPage, setPaymentPage] = useState(0);

  // Gift Card States
  const [showGiftCardSelection, setShowGiftCardSelection] = useState(true);
  const [giftCardLoading, setGiftCardLoading] = useState(false);
  const [availableGiftCards, setAvailableGiftCards] = useState([]);
  const [giftCardSearch, setGiftCardSearch] = useState("");
  // const [giftCardBalance, setGiftCardBalance] = useState(null);
  const [giftCardTopupInputFocused, setGiftCardTopupInputFocused] = useState("transactionId");
  const [giftCardTopupLayoutName, setGiftCardTopupLayoutName] = useState("default");
  const giftCardTopupKeyboardRef = useRef(null);
  const giftCardNumberRef = useRef(null);
  const giftCardPinRef = useRef(null);
  const giftCardTopupInputRef = useRef(null);
  const giftCardTopupCashRef = useRef(null);
  const giftCardTopupCardRef = useRef(null);
  const giftCardTopupUPIRef = useRef(null);
  const [financialAccountsData, setFinancialAccountsData] = useState([]);
  const [walletContext, setWalletContext] = useState(null);
  const [walletBankTransferPaymentMethod, setWalletBankTransferPaymentMethod] = useState(null);
  useEffect(() => {
    // Only proceed if setCustomersData function is available
    if (typeof setCustomersData === "function") {
      if (!customersData) {
        // Initialize with cart customer if available
        if (cart?.customer) {
          const initialCustomer = {
            ...cart.customer,
            currentBalance: cart.customer.currentBalance || 0,
            totalSpent: cart.customer.totalSpent || 0,
            joinDate: cart.customer.joinDate || new Date().toISOString(),
            transactions: cart.customer.transactions || [],
          };
          setCustomersData([initialCustomer]);
        } else {
          setCustomersData([]);
        }
      } else if (!Array.isArray(customersData) && typeof customersData === "object") {
        // Normalize to array if customersData is a single object
        setCustomersData([customersData]);
      }
    }
  }, [cart?.customer]); // Only depend on cart?.customer
  // Hardcoded customer data
  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  // Payment methods
  const paymentMethods = [
    { value: "Cash", label: "Cash" },
    { value: "Credit Card", label: "Credit Card" },
    { value: "Debit Card", label: "Debit Card" },
    { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "UPI", label: "UPI" },
    { value: "Digital Wallet", label: "Digital Wallet" },
  ];

  useEffect(async () => {
    await db.salesRep.toArray((res) => {
      setSalesRepData(res);
    });
  }, []);

  useEffect(() => {
    if (openSalesRep?.flag && salesRepRef.current) {
      setTimeout(() => {
        salesRepRef.current.focus();
      }, 10);
    }
  }, [openSalesRep?.flag]);

  useEffect(() => {
    if (isStockModal) {
      const timeout = setTimeout(() => {
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [isStockModal]);

  useEffect(() => {
    if (isNewGiftCardFlag) {
      setGiftCardLoading(true);
      getGiftCardData()
        .then((response) => {
          if (response.status === 200) {
            const data = JSON.parse(response.data?.data?.getGiftCards) || [];
            setAvailableGiftCards(data);
            setGiftCardLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching gift card data:", error);
        });
    }
  }, [isNewGiftCardFlag]);

  useEffect(() => {
    const initialWeights = {};
    cart?.items.forEach((item) => {
      initialWeights[item.lineId] = item.weight <= item?.availableQty ? item.weight : item?.availableQty || 0; // Store as string to allow flexible input
    });
    setItemWeights(initialWeights);
  }, [cart]);

  const renderThumbHorizontalScroll = ({ style, ...props }) => {
    const thumbStyle = {
      width: "0px",
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const fetchSalesRepData = async (searchTerm) => {
    const results = await db.salesRep.filter((res) => res.name.toLowerCase().includes(searchTerm.toLowerCase()) || res.code.includes(searchTerm)).toArray();
    return results;
  };

  useEffect(() => {
    const getFinancialAccountsData = async () => {
      const financialAccountsData = await db?.getFinancialAccounts?.toArray();
      setFinancialAccountsData(financialAccountsData);
    };
    getFinancialAccountsData();
  }, []);

  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSalesRepValue(value);

    const data = await fetchSalesRepData(value);
    setSalesRepData(data);
    if (!value) {
      setSalesRepData(data);
      return;
    }
  };

  useEffect(() => {
    const fetchSalesReps = async () => {
      if (openSalesRep?.flag) {
        try {
          const data = await fetchSalesRepData("");
          setSalesRepData(data);
          setSalesRepValue("");
        } catch (error) {
          console.error("Error fetching sales representatives:", error);
        }
      }
    };

    fetchSalesReps();
  }, [openSalesRep?.flag]);

  useEffect(() => {
    if (selectedPaymentMethod === "Card") {
      setShowCardAmountInput(false);
      cardPaymentForm.resetFields();
      setCurrentCardInput("");
      setCurrentUPIInput("");
    } else if (selectedPaymentMethod === "UPI") {
      setCurrentUPIInput("");
    }
  }, [selectedPaymentMethod]);

  useEffect(() => {
    if (showTopupModal) {
      setShowCardAmountInput(false);
      cardPaymentForm.resetFields();
      setCurrentCashInput("");
      setCurrentCardInput("");
      setCurrentUPIInput("");
      setRedeemAmount("");
      setDynamicPaymentInput("");
      setCashTendered(0);
      // setSelectedPaymentMethod("Cash");
      setFocusedInputField("topupAmount");
    }
  }, [showTopupModal, cardPaymentForm]);

  useEffect(() => {
    if (typeof setCart !== "function") {
      console.warn("setCart is not a function. Ensure it is passed as a prop from the parent component.");
      return;
    }
    if (!cart) {
      const initialCart = { payments: [], paid: 0, items: [], total: 0, customer: null };
      setCart(initialCart);
      localStorage.setItem("cartObj", JSON.stringify(initialCart));
    } else if (!cart.payments) {
      const updatedCart = { ...cart, payments: [], paid: cart.paid || 0 };
      setCart(updatedCart);
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    }
  }, [cart, setCart]);

  const handleCardPayment = async (values) => {
    if (!topupAmount || Number.parseFloat(topupAmount) < 0) {
      message.error(`${messages.info.valid_topup_amount}`);
      return;
    }
    if (posConfig?.transactionID === "Y") {
      setShowCardAmountInput(true);
    }
  };
  useEffect(() => {
    if (isWalletFlag) {
      // When drawer opens, set redeemAmount to remaining due (amount)
      setRedeemAmount(!isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00");
    } else {
      // When drawer closes, reset redeemAmount
      setRedeemAmount("");
    }
  }, [isWalletFlag, amount]);

  useEffect(() => {
    if (isBankTransferOpen) {
      // When drawer opens, set redeemAmount to remaining due (amount)
      setRedeemAmount(!isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00");
    } else {
      // When drawer closes, reset redeemAmount
      setRedeemAmount("");
    }
  }, [isBankTransferOpen, amount]);

  const walletPopup = () => {
    const currSymbol = currenciesList?.[0]?.symbolRightSide === "N" ? currenciesList[0].currSymbol : "";
    const currSymbolRight = currenciesList?.[0]?.symbolRightSide === "Y" ? currenciesList[0].currSymbol : "";
    const handleRedeemWallet = (value) => {
      if (value === "clear") {
        setRedeemAmount(""); // Clear the input
      } else if (value === "x") {
        setRedeemAmount((prev) => prev.slice(0, -1)); // Remove last character
      } else if (value === ".") {
        // Only allow one decimal point
        if (!redeemAmount.includes(".")) {
          setRedeemAmount((prev) => prev + value);
        }
      } else if (value === "00") {
        // Append "00" only if input is not empty or after a decimal
        if (redeemAmount !== "" || redeemAmount.includes(".")) {
          setRedeemAmount((prev) => prev + value);
        }
      } else {
        // Append number
        setRedeemAmount((prev) => prev + value);
      }
    };

    if (posConfig?.enable_customer_wallet !== "Y") return null;

    return (
      <Drawer
        centered
        closable={false}
        width="50%"
        headerStyle={{ background: "white", padding: "22px 10px", borderBottom: "none" }}
        height="75%"
        placement="bottom"
        bodyStyle={{ padding: "0% 7% 1% 7%", background: "#fff" }}
        footer={null}
        visible={isWalletFlag}
        onCancel={() => {
          setSelectedPaymentMethod({});
          setIswalletFlag(false);
          setRedeemAmount(""); // Reset redeemAmount on close
        }}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "2vh",
              fontSize: "1vw",
            }}
          >
            <p
              style={{
                fontSize: "1.5em",
                marginTop: "3vh",
                fontWeight: "500",
                color: "#0F0718",
                flex: 1,
                textAlign: "center",
              }}
            >
              Customer Wallet
            </p>
            <img
              src={Close}
              onClick={() => {
                setSelectedPaymentMethod({});
                setShowPayments(JSON.parse(localStorage.getItem("initialShowPayments")));
                setIswalletFlag(false);
                let PaymentMethods = getFilteredPaymentMethods() || [];
                const isPreOrderPage = window.location.pathname.includes("/preorder");
                if (isPreOrderPage) {
                  const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
                  const maxPaymentsToShow = isRefundScenario ? 3 : 3;
                  let payments =
                    PaymentMethods.length > maxPaymentsToShow
                      ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                          0,
                          tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === maxPaymentsToShow
                            ? maxPaymentsToShow
                            : cart.layAway === "Y"
                              ? maxPaymentsToShow
                              : maxPaymentsToShow
                        )
                      : PaymentMethods;

                  setShowPayments(payments);
                  setStartIndex(cart.layAway === "Y" && payments.length >= maxPaymentsToShow ? maxPaymentsToShow : payments.length);
                }
                setRedeemAmount(""); // Reset redeemAmount on close
              }}
              style={{
                marginLeft: "auto",
                paddingBottom: "4vh",
                paddingTop: "2vh",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
        }
      >
        <Row gutter={[24, 24]} style={{ height: "100%" }}>
          {/* Left half - Cards and Additional Info */}
          <Col span={12}>
            {selectedCustomer && selectedCustomer[0] ? (
              <>
                <Row gutter={[16, 0]} style={{ marginBottom: "1rem" }}>
                  <Col span={8}>
                    <Card
                      style={{
                        borderRadius: "8px",
                        textAlign: "center",
                        border: "1px solid #e8e8e8",
                        height: "20vh",
                        backgroundColor: "#fff",
                      }}
                    >
                      <img src={credit || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "2vh", marginBottom: "2vh" }} alt="" />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Current Balance</h4>
                      <h2 style={{ margin: "0.5rem", color: "#28a745", fontSize: "1rem", fontWeight: "bold" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      style={{
                        borderRadius: "8px",
                        textAlign: "center",
                        border: "1px solid #e8e8e8",
                        height: "20vh",
                        backgroundColor: "#fff",
                      }}
                    >
                      <img src={cash || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "2vh", marginBottom: "2vh" }} alt="" />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Total Spent</h4>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.totalSpent?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      style={{
                        borderRadius: "8px",
                        textAlign: "center",
                        border: "1px solid #e8e8e8",
                        height: "20vh",
                        backgroundColor: "#fff",
                      }}
                    >
                      <CalendarOutlined
                        style={{
                          height: "3vh",
                          fontSize: "1.7em",
                          paddingRight: "5px",
                          marginTop: "2vh",
                          marginBottom: "2vh",
                        }}
                      />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Member Since</h4>
                      <h2 style={{ margin: "0.5rem 0", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                        {selectedCustomer[0]?.joinDate ? formatDate(selectedCustomer[0].joinDate) : ""}
                      </h2>
                    </Card>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: "1rem" }}>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Wallet Balance</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Bill Amount</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {!isNaN(cart.total) ? parseFloat(cart.total).toFixed(2) : cart.total.toFixed(2)}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Remaining Due</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {!isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <div style={{ textAlign: "center", padding: "1rem", color: "#666" }}>
                <h4>No customer selected</h4>
              </div>
            )}
          </Col>

          {/* Right half - Keypad */}
          <Col span={12}>
            <Col span={20} pull={2} push={2} style={{ padding: "" }}>
              <label>
                <span
                  style={{
                    color: "#0F0718",
                    fontSize: "1.25em",
                    fontWeight: "500",
                    marginBottom: "3vh",
                  }}
                >
                  Redeem Wallet Amount
                </span>
              </label>
              <Input
                id="amountNumber"
                value={redeemAmount} // Bind to redeemAmount
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only valid numeric input (including decimal point)
                  if (value === "" || /^(\d*\.?\d*)$/.test(value)) {
                    setRedeemAmount(value);
                  }
                }}
                onFocus={() => setInputFocused("amount")}
                size="large"
                onPressEnter={(e) => e.preventDefault()}
                allowClear={false}
                style={{
                  ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                  padding: "1.5vh 1vw",
                  fontSize: "1em",
                  marginBottom: "2vh",
                  border: "1px solid gray",
                }}
              />
            </Col>
            <Row style={{ padding: "0 8%" }} gutter={[8, 6]}>
              <Col span={6}>
                <button
                  id="sm-amount-button1"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("1");
                    e.preventDefault();
                  }}
                >
                  1
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button2"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("2");
                    e.preventDefault();
                  }}
                >
                  2
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button3"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("3");
                    e.preventDefault();
                  }}
                >
                  3
                </button>
              </Col>
              <Col span={6}>
                <button
                  className="amt-dial-btn-gift"
                  id="sm-amount-buttonRemove"
                  onClick={(e) => {
                    handleRedeemWallet("x");
                    e.preventDefault();
                  }}
                >
                  <img src={CancelArrow} alt="back space" width={25} height={15} />
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button4"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("4");
                    e.preventDefault();
                  }}
                >
                  4
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button5"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("5");
                    e.preventDefault();
                  }}
                >
                  5
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button6"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("6");
                    e.preventDefault();
                  }}
                >
                  6
                </button>
              </Col>
              <Col span={6}>
                <button
                  onClick={(e) => {
                    handleRedeemWallet("clear");
                    e.preventDefault();
                  }}
                  id="sm-amount-addQuantity"
                  className="amt-dial-btn-gift"
                >
                  Clear
                </button>
              </Col>
              <Col span={18}>
                <Row gutter={[8, 6]}>
                  <Col span={8}>
                    <button
                      id="sm-amount-button7"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("7");
                        e.preventDefault();
                      }}
                    >
                      7
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button8"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("8");
                        e.preventDefault();
                      }}
                    >
                      8
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button9"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("9");
                        e.preventDefault();
                      }}
                    >
                      9
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button0"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("0");
                        e.preventDefault();
                      }}
                    >
                      0
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-buttonDot"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet(".");
                        e.preventDefault();
                      }}
                    >
                      .
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button00"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("00");
                        e.preventDefault();
                      }}
                    >
                      00
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-buttonEnter"
                  className="amt-dial-btn-gift2"
                  onClick={async (e) => {
                    e.preventDefault();

                    const amountValue = parseFloat(redeemAmount);
                    const walletBalance = parseFloat(selectedCustomer[0]?.currentBalance || 0);
                    const remainingDue = parseFloat(amount);

                    if (!redeemAmount || isNaN(amountValue) || amountValue <= 0) {
                      message.warning(`${messages.info.valid_amount}`);
                      return;
                    }

                    if (amountValue > walletBalance) {
                      message.warning(`${messages.warnings.payment.redeem_wallet_amount_exceeds}`);
                      return;
                    }

                    if (walletContext !== "giftcardtopup" && amountValue > remainingDue) {
                      message.warning(`${messages.warnings.payment.redeem_wallet_amount_exceeds_due}`);
                      return;
                    }
                    if (walletContext === "giftcardtopup") {
                      const topupTotal = parseFloat(giftCardTopupAmount);
                      if (!topupTotal || topupTotal <= 0) {
                        message.warning("Please enter a valid top-up amount first");
                        return;
                      }
                      const remaining = topupTotal - giftCardTotalPaid;
                      if (amountValue > remaining) {
                        message.warning(`Wallet payment exceeds remaining top-up amount. Remaining: ${currSymbol}${remaining.toFixed(2)}${currSymbolRight}`);
                        return;
                      }
                    }

                    const tillData = JSON.parse(localStorage.getItem("tillData")) || {};
                    const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;

                    try {
                      // 🟡 IF OTP FLAG ENABLED
                      if (posConfig?.enableLoyalty === "Y") {
                        const res = await verifyWalletRedemption(cart.customer.cwrCustomerId, bunitId, amountValue);

                        const status = res?.data?.data?.verifyWalletRedemption?.status;

                        if (status === "200") {
                          setWalletOtpAmount(amountValue);
                          setShowWalletOtpModal(true); // 👉 open wallet OTP modal
                          return;
                          return;
                        } else {
                          message.error(res?.data?.data?.verifyWalletRedemption?.message);
                          return;
                        }
                      }

                      // 🟢 ORIGINAL FLOW (UNCHANGED)
                      const payload = {
                        bunitId,
                        customerId: cart.customer.cwrCustomerId,
                        trxType: "WD",
                        trxValue: amountValue,
                        tillId: tillData?.tillAccess.cwrTill.cwrTillID,
                      };

                      const response = await upsertWalletTransactionService(payload);

                      if (response?.status !== "200") {
                        message.error("Wallet deduction failed");
                        return;
                      }

                      const updatedCustomer = {
                        ...selectedCustomer[0],
                        currentBalance: walletBalance - amountValue,
                      };

                      setSelectedCustomer([updatedCustomer]);
                      if (walletContext === "giftcardtopup") {
                        // Feed into walletPayments (same as cash/card/upi in gift card topup)
                        await requestPayment(giftCardTopupPaymentMethod, amountValue.toFixed(2), undefined, true);
                        setRedeemAmount("");
                        setIswalletFlag(false);
                        setWalletContext(null);
                        // Now check if topup is fully paid — same logic as handleEnterTopup after requestPayment
                        const topupTotal = parseFloat(giftCardTopupAmount).toFixed(2);
                        const updatedTotalPaid = (giftCardTotalPaid + amountValue).toFixed(2);
                        if (parseFloat(updatedTotalPaid) >= parseFloat(topupTotal)) {
                          // trigger the same finalization as handleEnterTopup
                          await finalizeGiftCardTopup(topupTotal);
                        } else {
                          const remaining = (parseFloat(topupTotal) - parseFloat(updatedTotalPaid)).toFixed(2);
                          message.success(
                            `Wallet payment of ${currSymbol}${amountValue.toFixed(2)}${currSymbolRight} added. Remaining: ${currSymbol}${remaining}${currSymbolRight}`
                          );
                        }
                      } else {
                        requestPayment({ ...selectedPaymentMethod, walletAlreadyDeducted: true }, amountValue.toFixed(2));

                        setRedeemAmount("");
                        setIswalletFlag(false);
                        localStorage.removeItem("walletDataForCardIntegration");
                      }
                    } catch (err) {
                      message.error("Wallet deduction error");
                    }
                  }}
                >
                  Enter
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    );
  };

  // const fileName = financialDocument?.fileName || null;
  const fileName = financialDocument?.[financialDocument.length - 1]?.fileName || null;

  const handleFinancialFileUpload = async (file, docName) => {
    if (!file) return;
    setFinancialDocUploaded(true);

    try {
      const fileToUpload = file.size > 4 * 1024 * 1024 && file.type.startsWith("image/") ? await compressImage(file, 1920, 0.75) : file;
      const buffer = await fileToUpload.arrayBuffer();
      const fileData = Array.from(new Uint8Array(buffer));

      const response = await fetch(`${process.env.REACT_APP_uploadDocumentUrl}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fileName: fileToUpload.name,
          fileType: fileToUpload.type,
          fileData,
        }),
      });

      const result = await response.json();
      console.log("Upload response:", result);

      if (!response.ok) throw new Error(result?.error || "Upload failed");

      const { url } = result;
      financialForm.setFieldsValue({
        financialFile: url || null,
      });
      setFinancialDocument((prev) => [
        ...(Array.isArray(prev) ? prev : []),
        {
          docID: "",
          docName,
          docUrl: url,
          fileName: file.name,
        },
      ]);

      message.success("Attachment has been uploaded succesfully.");
      return url;
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Failed to upload document");
      return null;
    } finally {
      setFinancialDocUploaded(false);
    }
  };

  const bankTransferPopup = () => {
    const handleBankTransferAmount = (value) => {
      if (value === "clear") {
        setRedeemAmount(""); // Clear the input
      } else if (value === "x") {
        setRedeemAmount((prev) => prev.slice(0, -1)); // Remove last character
      } else if (value === ".") {
        // Only allow one decimal point
        if (!redeemAmount.includes(".")) {
          setRedeemAmount((prev) => prev + value);
        }
      } else if (value === "00") {
        // Append "00" only if input is not empty or after a decimal
        if (redeemAmount !== "" || redeemAmount.includes(".")) {
          setRedeemAmount((prev) => prev + value);
        }
      } else {
        // Append number
        setRedeemAmount((prev) => prev + value);
      }
    };

    return (
      <Drawer
        zIndex={2000}
        getContainer={false}
        mask={true}
        maskClosable={false}
        centered
        closable={false}
        width="50%"
        headerStyle={{ background: "white", padding: "22px 10px", borderBottom: "none" }}
        // height="75%"
        height="87vh"
        placement="bottom"
        bodyStyle={{ padding: "0% 7% 1% 7%", background: "#fff" }}
        footer={null}
        visible={isBankTransferOpen}
        className="filter"
        onCancel={() => {
          setSelectedPaymentMethod({});
          setShowPayments(JSON.parse(localStorage.getItem("initialShowPayments")));
          setIsBankTransferOpen(false);
          setRedeemAmount("");
          financialForm.resetFields();
          setFinancialDocument(null);
        }}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "2vh",
              fontSize: "1vw",
            }}
          >
            <p
              style={{
                fontSize: "1.5em",
                marginTop: "3vh",
                fontWeight: "500",
                color: "#0F0718",
                flex: 1,
                textAlign: "center",
              }}
            >
              Bank Transfer Payment
            </p>
            <img
              src={Close}
              onClick={() => {
                setSelectedPaymentMethod({});
                setShowPayments(JSON.parse(localStorage.getItem("initialShowPayments")));
                setIsBankTransferOpen(false);
                setRedeemAmount("");
                financialForm.resetFields();
                setFinancialDocument(null);
              }}
              style={{
                marginLeft: "auto",
                paddingBottom: "4vh",
                paddingTop: "2vh",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
        }
      >
        <Row gutter={[24, 24]} style={{ height: "100%", marginTop: "3vh" }}>
          {/* Left half - Cards and Additional Info */}

          <Col span={12}>
            <Form form={financialForm}>
              <Form.Item
                name="financialAccount"
                label={<span style={{ color: "#0F0718", fontSize: "1.15em", fontWeight: "500", paddingBottom: "0px" }}>Bank Account</span>}
                labelCol={{ span: 24, style: { paddingBottom: 0 } }}
                wrapperCol={{ span: 24 }}
                style={{ width: "75%" }}
                rules={[{ required: true, message: "Please select an bank account" }]}
              >
                <Select
                  getPopupContainer={(trigger) => trigger.parentNode}
                  placeholder="Select Type"
                  size="large"
                  style={{
                    fontSize: "1.15em",
                    width: "100%",
                    borderRadius: "4px",
                  }}
                  className="custom-select-bank-account"
                  dropdownStyle={{ fontSize: "1.15em" }}
                >
                  {financialAccountsData.map((item) => (
                    <Option key={item.fin_financial_acct_id} value={item.fin_financial_acct_id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="transactionId"
                label={<span style={{ color: "#0F0718", fontSize: "1.15em", fontWeight: "500" }}>Transaction ID</span>}
                labelCol={{ span: 24, style: { paddingBottom: 0 } }}
                wrapperCol={{ span: 24 }}
                style={{ width: "75%" }}
                rules={[{ required: true, message: "Please enter a transaction ID" }]}
              >
                <Input
                  placeholder="Enter Transaction ID"
                  size="large"
                  style={{
                    height: "40px",
                    borderRadius: "6px",
                    fontSize: "1em",
                  }}
                />
              </Form.Item>
              <Form.Item
                name="date"
                label={<span style={{ color: "#0F0718", fontSize: "1.15em", fontWeight: "500" }}>Date</span>}
                labelCol={{ span: 24, style: { paddingBottom: 0 } }}
                wrapperCol={{ span: 24 }}
                style={{ width: "75%", fontSize: "1em" }}
                rules={[{ required: true, message: "Please enter a date" }]}
              >
                <DatePicker
                  getPopupContainer={(trigger) => trigger.parentNode}
                  style={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "6px",
                    fontSize: "1em",
                  }}
                  size="middle"
                  format="DD/MM/YYYY"
                />
              </Form.Item>
              <Form.Item
                name="financialFile"
                style={{
                  fontSize: "1vw",
                  paddingBottom: 0,
                }}
                label={<span style={{ color: "#0F0718", fontSize: "1.15em", fontWeight: "500" }}>Upload File</span>}
                labelCol={{ span: 24, style: { paddingBottom: 0 } }}
                wrapperCol={{ span: 24 }}
                rules={[]}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <label
                    style={{
                      border: "1px solid #d9d9d9",
                      padding: "6px 16px",
                      borderRadius: "4px",
                      cursor: financialDocs?.length > 0 ? "not-allowed" : "pointer",
                      background: financialDocs?.length > 0 ? "#f5f5f5" : "#fff",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      opacity: financialDocs?.length > 0 ? 0.7 : 1,
                    }}
                  >
                    {financialDocs?.length > 0 ? "Uploading..." : "Choose File"}

                    <input
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf"
                      style={{ display: "none" }}
                      disabled={financialDocs?.length > 0}
                      // onChange={(e) => handleFinancialFileUpload(e, "Financial File")}
                      onChange={(e) => handleFinancialFileUpload(e.target.files[0], "Financial File")}
                    />
                  </label>

                  <span
                    style={{
                      fontSize: "13px",
                      color: "#595959",
                      maxWidth: "220px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {fileName || "No file chosen"}
                  </span>
                </div>
              </Form.Item>
            </Form>
          </Col>

          {/* Right half - Keypad */}
          <Col span={12}>
            <Col span={20} pull={2} push={2} style={{ padding: "" }}>
              <label>
                <span
                  style={{
                    color: "#0F0718",
                    fontSize: "1.25em",
                    fontWeight: "500",
                    marginBottom: "3vh",
                  }}
                >
                  Bank Transfer Amount
                </span>
              </label>
              <Input
                id="amountNumber"
                value={bankTransferContext === "giftcardtopup" ? (redeemAmount === "" ? "0" : redeemAmount) : redeemAmount}
                onChange={(e) => {
                  let value = e.target.value;
                  if (bankTransferContext === "giftcardtopup" && redeemAmount === "" && value === "0") {
                    value = "";
                  }
                  if (value === "" || /^(\d*\.?\d*)$/.test(value)) {
                    setRedeemAmount(value);
                  }
                }}
                onFocus={() => {
                  setInputFocused("amount");

                  // 🔥 remove 0 when user clicks input
                  if (bankTransferContext === "giftcardtopup" && redeemAmount === "") {
                    setRedeemAmount("");
                  }
                }}
                size="large"
                onPressEnter={(e) => e.preventDefault()}
                allowClear={false}
                style={{
                  ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                  padding: "1.5vh 1vw",
                  fontSize: "1em",
                  marginBottom: "2vh",
                  border: "1px solid gray",
                }}
              />
            </Col>
            <Row style={{ padding: "0 8%" }} gutter={[8, 6]}>
              <Col span={6}>
                <button
                  id="sm-amount-button1"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleBankTransferAmount("1");
                    e.preventDefault();
                  }}
                >
                  1
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button2"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleBankTransferAmount("2");
                    e.preventDefault();
                  }}
                >
                  2
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button3"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleBankTransferAmount("3");
                    e.preventDefault();
                  }}
                >
                  3
                </button>
              </Col>
              <Col span={6}>
                <button
                  className="amt-dial-btn-gift"
                  id="sm-amount-buttonRemove"
                  onClick={(e) => {
                    handleBankTransferAmount("x");
                    e.preventDefault();
                  }}
                >
                  <img src={CancelArrow} alt="back space" width={25} height={15} />
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button4"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleBankTransferAmount("4");
                    e.preventDefault();
                  }}
                >
                  4
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button5"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleBankTransferAmount("5");
                    e.preventDefault();
                  }}
                >
                  5
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button6"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleBankTransferAmount("6");
                    e.preventDefault();
                  }}
                >
                  6
                </button>
              </Col>
              <Col span={6}>
                <button
                  onClick={(e) => {
                    handleBankTransferAmount("clear");
                    e.preventDefault();
                  }}
                  id="sm-amount-addQuantity"
                  className="amt-dial-btn-gift"
                >
                  Clear
                </button>
              </Col>
              <Col span={18}>
                <Row gutter={[8, 6]}>
                  <Col span={8}>
                    <button
                      id="sm-amount-button7"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleBankTransferAmount("7");
                        e.preventDefault();
                      }}
                    >
                      7
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button8"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleBankTransferAmount("8");
                        e.preventDefault();
                      }}
                    >
                      8
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button9"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleBankTransferAmount("9");
                        e.preventDefault();
                      }}
                    >
                      9
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button0"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleBankTransferAmount("0");
                        e.preventDefault();
                      }}
                    >
                      0
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-buttonDot"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleBankTransferAmount(".");
                        e.preventDefault();
                      }}
                    >
                      .
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button00"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleBankTransferAmount("00");
                        e.preventDefault();
                      }}
                    >
                      00
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-buttonEnter"
                  className="amt-dial-btn-gift2"
                  disabled={financialDocUploaded}
                  style={{
                    cursor: financialDocUploaded ? "not-allowed" : "pointer",
                    opacity: financialDocUploaded ? 0.6 : 1,
                  }}
                  // onClick={async (e) => {
                  //   e.preventDefault();
                  //   try {
                  //     const values = await financialForm.validateFields();

                  //     const amountValue = parseFloat(redeemAmount);
                  //     if (!redeemAmount || isNaN(amountValue) || amountValue <= 0) {
                  //       message.warning(`${messages.info.valid_amount}`);
                  //       return;
                  //     }
                  //     const updatedPaymentMethod = {
                  //       ...selectedPaymentMethod,
                  //       financialAccount: values.financialAccount,
                  //       transactionId: values.transactionId,
                  //       transactionDate: values.date ? values.date.format("YYYY-MM-DD") : null,
                  //       financialFile: values.financialFile || null,
                  //     };
                  //     handlePayment({
                  //       selectedPaymentMethod: updatedPaymentMethod,
                  //       cart,
                  //       amount: redeemAmount,
                  //       posConfig,
                  //       tillData,
                  //       isOnline,
                  //       isExchange,
                  //       showConfirm,
                  //       requestPayment,
                  //       processOrder,
                  //       setShowCardPaymnteModal,
                  //       setPaymentType,
                  //       setCardPaymnetError,
                  //       messages,
                  //       t,
                  //       enableGiftCardCheck: true,
                  //       enablePoleDisplay: false,
                  //       enableSetNumb: true,
                  //       setNumb,
                  //     });
                  //   } catch (error) {
                  //     console.log("Validation errors:", error);

                  //     // Optional: scroll to first error
                  //     financialForm.scrollToField(error.errorFields?.[0]?.name);

                  //     return;
                  //   }
                  // }}
                  onClick={async (e) => {
                    e.preventDefault();
                    try {
                      const currSymbol = currenciesList?.[0]?.symbolRightSide === "N" ? currenciesList[0].currSymbol : "";
                      const currSymbolRight = currenciesList?.[0]?.symbolRightSide === "Y" ? currenciesList[0].currSymbol : "";
                      const values = await financialForm.validateFields();
                      const amountValue = parseFloat(redeemAmount);
                      if (!redeemAmount || isNaN(amountValue) || amountValue <= 0) {
                        message.warning(`${messages.info.valid_amount}`);
                        return;
                      }

                      const updatedPaymentMethod = {
                        ...(bankTransferContext === "giftcardtopup"
                          ? giftCardTopupPaymentMethod
                          : bankTransferContext === "wallettopup" || bankTransferContext === "walletrefund"
                            ? walletBankTransferPaymentMethod // ✅ wallet's own state
                            : selectedPaymentMethod), // normal POS
                        financialAccount: values.financialAccount,
                        transactionId: values.transactionId,
                        transactionDate: values.date ? values.date.format("YYYY-MM-DD") : null,
                        financialFile: values.financialFile || null,
                        ...(bankTransferContext === "wallettopup" || bankTransferContext === "walletrefund" ? { isBankTransfer: "Y" } : {}),
                      };

                      if (bankTransferContext === "wallettopup" || bankTransferContext === "walletrefund") {
                        const walletTotal = parseFloat(topupAmount);
                        if (!walletTotal || walletTotal <= 0) {
                          message.warning("Please enter a valid amount");
                          return;
                        }
                        const walletTotalFixed = walletTotal.toFixed(2);

                        const rawPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];
                        const currentTotalPaid = rawPayments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

                        if (currentTotalPaid + amountValue > parseFloat(walletTotalFixed)) {
                          const remaining = (parseFloat(walletTotalFixed) - currentTotalPaid).toFixed(2);
                          message.error(
                            `Bank Transfer payment exceeds ${bankTransferContext === "walletrefund" ? "refund" : "top-up"} amount. Remaining: ${currSymbol}${remaining}${currSymbolRight}`
                          );
                          return;
                        }
                        console.log("🔥 updatedPaymentMethod going into requestPayment:", JSON.stringify(updatedPaymentMethod));
                        try {
                          await requestPayment(updatedPaymentMethod, amountValue.toFixed(2), undefined, true);

                          const updatedTotalPaid = (currentTotalPaid + amountValue).toFixed(2);

                          setIsBankTransferOpen(false);
                          setRedeemAmount("");
                          financialForm.resetFields();
                          setFinancialDocument(null);
                          setBankTransferContext("payment");
                          setWalletBankTransferPaymentMethod(null);

                          if (parseFloat(updatedTotalPaid) >= parseFloat(walletTotalFixed)) {
                            // ✅ All payments collected — call the SAME finalization as enterTotalQty does
                            if (bankTransferContext === "walletrefund") {
                              await handleWalletRefundComplete(walletTotalFixed); // ✅ same as enterTotalQty refund path
                            } else {
                              await handleWalletTopUp(walletTotalFixed); // ✅ same as enterTotalQty topup path
                            }
                            localStorage.removeItem("walletPayments");
                          } else {
                            // ✅ Partial payment — show remaining
                            const remaining = (parseFloat(walletTotalFixed) - parseFloat(updatedTotalPaid)).toFixed(2);
                            message.success(
                              `Bank Transfer payment of ${currSymbol}${amountValue.toFixed(2)}${currSymbolRight} added. Remaining: ${currSymbol}${remaining}${currSymbolRight}`
                            );
                            //autoFillEnterAmount(remaining); // ✅ auto-fill remaining for next payment
                          }
                        } catch (err) {
                          console.log("Wallet bank transfer error:", err);
                          message.error("Bank Transfer payment failed");
                        }
                        return;
                      }

                      // ✅ Gift card topup context
                      if (bankTransferContext === "giftcardtopup") {
                        const topupValue = parseFloat(giftCardTopupAmount);
                        if (!topupValue || topupValue <= 0) {
                          message.warning("Please enter a valid top-up amount");
                          return;
                        }
                        const topupTotal = parseFloat(topupValue).toFixed(2);

                        // Recalculate totalPaid from localStorage at the time of click
                        const rawPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];
                        const currentTotalPaid = rawPayments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

                        if (currentTotalPaid + amountValue > parseFloat(topupTotal)) {
                          const remaining = (parseFloat(topupTotal) - currentTotalPaid).toFixed(2);
                          message.error(`Bank Transfer payment exceeds top-up amount. Remaining: ${currSymbol}${remaining}${currSymbolRight}`);
                          return;
                        }

                        try {
                          await requestPayment(updatedPaymentMethod, amountValue.toFixed(2), undefined, true);

                          const updatedTotalPaid = (currentTotalPaid + amountValue).toFixed(2);

                          // Close bank transfer drawer
                          setIsBankTransferOpen(false);
                          setRedeemAmount("");
                          financialForm.resetFields();
                          setFinancialDocument(null);
                          setBankTransferContext("payment");

                          if (parseFloat(updatedTotalPaid) >= parseFloat(topupTotal)) {
                            // ✅ All payments collected — finalize topup
                            try {
                              const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
                              const latestPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];
                              const latestMatchedPayments = latestPayments.map((payment) => {
                                const matchedMethod = showPayments?.find((m) => m.finPaymentmethodId === payment.finPaymentmethodID);
                                return { ...matchedMethod, ...payment };
                              });
                              const paymentsGQL = latestMatchedPayments
                                .map((p) => {
                                  const bankTransferFields =
                                    p.isBankTransfer === "Y"
                                      ? `
      financialAccountId: ${p.financialAccountId ? `"${p.financialAccountId}"` : null}
      transactionId: ${p.transactionId ? `"${p.transactionId}"` : null}
      transactionTime: ${p.transactionTime ? `"${p.transactionTime}"` : null}
      imageUrl: ${p.imageUrl ? `"${p.imageUrl.replace(/\\/g, "\\\\")}"` : null}`
                                      : "";

                                  return `{
      finPaymentmethodID: "${p.finPaymentmethodId || p.finPaymentmethodID}"
      amount: ${parseFloat(p.amount)}
      ${bankTransferFields}
    }`;
                                })
                                .join(",");

                              const upsertData = {
                                query: `mutation {
                upsertGiftCardTransaction(giftCardTransactions: [{
                  cardNo: ${giftCardNumber ? `"${giftCardNumber}"` : null}
                  type: "TO"
                  referenceNo: "${uuidv4().replace(/-/g, "").toUpperCase()}"
                  amount: ${parseFloat(topupTotal)}
                  cardPin: ${giftCardPin ? `"${giftCardPin}"` : null}
                  tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
                  b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
                  bunitId: "${bunitId}"
                  payments: [${paymentsGQL}]
                }]) {
                  status
                  message
                }
              }`,
                              };

                              const topupResponse = await upsertGiftCardTransaction(upsertData);
                              const result = topupResponse?.data?.data?.upsertGiftCardTransaction;

                              if (result?.status === "200") {
                                message.success(`Gift Card topped up with ${currSymbol}${topupTotal}${currSymbolRight}`);
                                localStorage.removeItem("walletPayments");
                                resetGiftCardTopup();
                                await handleCheckGiftCardBalance();
                              } else {
                                message.error(result?.message || "Gift Card top-up failed");
                                localStorage.removeItem("walletPayments");
                                resetGiftCardTopup();
                              }
                            } catch (topupErr) {
                              console.log("Gift Card Topup error:", topupErr);
                              message.error("Gift Card top-up service failed");
                              localStorage.removeItem("walletPayments");
                              resetGiftCardTopup();
                            }
                          } else {
                            // ✅ Partial payment added — show remaining
                            const remaining = (parseFloat(topupTotal) - parseFloat(updatedTotalPaid)).toFixed(2);
                            message.success(
                              `Bank Transfer payment of ${currSymbol}${amountValue.toFixed(2)}${currSymbolRight} added. Remaining: ${currSymbol}${remaining}${currSymbolRight}`
                            );
                            // Auto-fill remaining for next payment
                            giftCardAutoFillAmount(giftCardTopupAmount);
                          }
                        } catch (err) {
                          console.log("Bank Transfer topup error:", err);
                          message.error("Bank Transfer payment failed");
                        }
                      } else {
                        // ✅ Normal POS payment — unchanged
                        handlePayment({
                          selectedPaymentMethod: updatedPaymentMethod,
                          cart,
                          amount: redeemAmount,
                          posConfig,
                          tillData,
                          isOnline,
                          isExchange,
                          showConfirm,
                          requestPayment,
                          processOrder,
                          setShowCardPaymnteModal,
                          setPaymentType,
                          setCardPaymnetError,
                          messages,
                          t,
                          enableGiftCardCheck: true,
                          enablePoleDisplay: false,
                          enableSetNumb: true,
                          setNumb,
                        });
                      }
                    } catch (error) {
                      console.log("Validation errors:", error);
                      financialForm.scrollToField(error.errorFields?.[0]?.name);
                    }
                  }}
                >
                  Enter
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    );
  };

  // Gift Card Check Balance Handler

  const handleGiftCardGenericAmount = (value) => {
    if (value === "x") {
      setGiftCardGenericInput((prev) => prev.slice(0, -1));
    } else if (value === "clear") {
      setGiftCardGenericInput("");
    } else {
      setGiftCardGenericInput((prev) => {
        if (value === "." && prev.includes(".")) return prev;
        if (value === "00" && prev === "") return prev;
        return prev + value;
      });
    }
  };

  // Gift Card Topup Handler
  // const handleGiftCardTopup = () => {
  //   if (!giftCardNumber) {
  //     message.warning("Please enter Gift Card Number first");
  //     return;
  //   }
  //   setShowGiftCardTopup(true);
  //   const cashPayment = _.sortBy(
  //     showPayments?.filter((pm) => ["cash", "card", "upi"].includes(pm.name.toLowerCase())),
  //     ["sequenceNo", "name"]
  //   )?.[0];
  //   setGiftCardTopupPaymentMethod(cashPayment || null);
  //   setGiftCardTopupFocusedField("topupAmount");
  //   setGiftCardTopupDenomKeyboard(cashPayment?.name?.toLowerCase() === "cash");
  // };
  const handleGiftCardTopup = () => {
    setShowGiftCardTopup(true);
    setGiftCardTopupPaymentPage(0);

    // Parse preferences and get methods — same logic as giftCardPopup computes
    const gcPrefs = (() => {
      try {
        const raw = tillData?.tillAccess?.giftCardPreferences;
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    })();

    const selCard = availableGiftCards?.find((card) => card?.card_no === giftCardNumber);
    const selTypeId = selCard?.cwr_giftcard_type_id;
    const activePref = selTypeId ? gcPrefs.find((p) => p.cwr_giftcard_type_id === selTypeId) : null;
    const paySettings = activePref?.paymentsettings || null;

    const allMethods = tillData?.tillAccess?.csBunit?.paymentMethodList || [];
    const methods = _.sortBy(
      paySettings
        ? allMethods.filter((pm) =>
            paySettings
              .filter((s) => s.topup === "Y")
              .map((s) => s.fin_paymentmethod_id)
              .includes(pm.finPaymentmethodId)
          )
        : allMethods,
      ["sequenceNo", "name"]
    );

    if (methods.length > 0) {
      const firstMethod = methods[0];
      setGiftCardTopupPaymentMethod(firstMethod);
      if (firstMethod.isBankTransfer === "Y") {
        setBankTransferContext("giftcardtopup");
        setIsBankTransferOpen(true);
        setRedeemAmount("");
        financialForm.resetFields();
        setFinancialDocument(null);
        return;
      }
      setGiftCardTopupDenomKeyboard(firstMethod.name?.toLowerCase() === "cash");
      setGiftCardTopupShowCardAmountInput(firstMethod.name?.toLowerCase() === "card" && posConfig?.transactionID === "Y" ? false : true);
      setTimeout(() => {
        giftCardTopupInputRef.current?.focus();
        setGiftCardTopupFocusedField("topupAmount");
      }, 50);
    }
  };

  // Gift Card Topup Keypad Handler
  const handleGiftCardTopupKeypad = (value) => {
    let currentValue = "";
    const field = giftCardTopupFocusedField;
    if (field === "topupAmount") {
      currentValue = giftCardTopupAmount;
    } else if (field === "cashInput") {
      currentValue = giftCardTopupCashInput;
    } else if (field === "cardInput") {
      currentValue = giftCardTopupCardInput;
    } else if (field === "upiInput") {
      currentValue = giftCardTopupUPIInput;
    }

    let newValue = "";
    if (value === "clear") {
      newValue = "";
    } else if (value === "x") {
      newValue = currentValue.slice(0, -1) || "";
    } else if (value === ".") {
      newValue = !currentValue.includes(".") ? currentValue + value : currentValue;
    } else {
      newValue = currentValue + value;
    }

    const sanitizedValue = newValue.replace(/[^0-9.]/g, "");
    const parts = sanitizedValue.split(".");
    if (parts.length > 2 || (parts.length === 2 && parts[1].length > 2)) return;

    if (field === "topupAmount") {
      setGiftCardTopupAmount(sanitizedValue);
    } else if (field === "cashInput") {
      setGiftCardTopupCashInput(sanitizedValue);
    } else if (field === "cardInput") {
      setGiftCardTopupCardInput(sanitizedValue);
    } else if (field === "upiInput") {
      setGiftCardTopupUPIInput(sanitizedValue);
    }
  };

  // Gift Card Topup Denomination Click Handler
  const handleGiftCardTopupDenomClick = (value) => {
    const sanitizedValue = Number.parseFloat(value.toString().replace(/[^0-9.]/g, "")) || 0;
    const field = giftCardTopupFocusedField;
    if (field === "topupAmount") {
      const currentValue = Number.parseFloat(giftCardTopupAmount) || 0;
      setGiftCardTopupAmount((currentValue + sanitizedValue).toFixed(2));
    } else if (field === "cashInput") {
      const currentValue = Number.parseFloat(giftCardTopupCashInput) || 0;
      setGiftCardTopupCashInput((currentValue + sanitizedValue).toFixed(2));
    } else if (field === "cardInput") {
      const currentValue = Number.parseFloat(giftCardTopupCardInput) || 0;
      setGiftCardTopupCardInput((currentValue + sanitizedValue).toFixed(2));
    } else if (field === "upiInput") {
      const currentValue = Number.parseFloat(giftCardTopupUPIInput) || 0;
      setGiftCardTopupUPIInput((currentValue + sanitizedValue).toFixed(2));
    }
  };

  // Reset all gift card state
  const resetGiftCardState = () => {
    // setIsNewGiftCardFlag(false);
    setGiftCardNumber("");
    setGiftCardPin("");
    setGiftCardBalance(null);
    setShowGiftCardSelection(true);
    setGiftCardSearch("");
    resetGiftCardTopup();
  };

  // Gift Card Popup
  const giftCardPopup = () => {
    if (!isNewGiftCardFlag) return null;

    const billAmount = !isNaN(cart?.total) ? parseFloat(cart.total).toFixed(2) : "0.00";
    const currSymbol = currenciesList?.[0]?.symbolRightSide === "N" ? currenciesList[0].currSymbol : "";
    const currSymbolRight = currenciesList?.[0]?.symbolRightSide === "Y" ? currenciesList[0].currSymbol : "";

    const closeAll = () => {
      setSelectedPaymentMethod({});
      setIsNewGiftCardFlag(false);
      setAvailableGiftCards([]);
      resetGiftCardState();
      let methods = getFilteredPaymentMethods() || [];
      const isPreOrderPage = window.location.pathname.includes("/preorder");
      if (isPreOrderPage) {
        const maxPaymentsToShow = 3;
        let payments = methods.length > maxPaymentsToShow ? _.sortBy(methods, "sequenceNo").slice(0, maxPaymentsToShow) : methods;
        setShowPayments(payments);
        setStartIndex(payments.length);
      }
    };

    // const giftCardTopupPaymentMethods = _.sortBy(
    //   showPayments?.filter((pm) => ["cash", "card", "upi"].includes(pm.name.toLowerCase())),
    //   ["sequenceNo", "name"]
    // );
    // Parse giftCardPreferences from tillData
    // Parse giftCardPreferences from tillData
    const giftCardPreferences = (() => {
      try {
        const raw = tillData?.tillAccess?.giftCardPreferences;
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    })();

    // Match the selected gift card's type ID against giftCardPreferences
    // giftCardNumber is set when user clicks ADD on a card from the selection list
    // We also need the type ID — find the selected card from availableGiftCards
    const selectedGiftCard = availableGiftCards?.find((card) => card?.card_no === giftCardNumber);
    const selectedGiftCardTypeId = selectedGiftCard?.cwr_giftcard_type_id;

    // Find the matching preference by type ID
    const activeGiftCardPreference = selectedGiftCardTypeId ? giftCardPreferences.find((pref) => pref.cwr_giftcard_type_id === selectedGiftCardTypeId) : null;

    const giftCardPaymentSettings = activeGiftCardPreference?.paymentsettings || null;

    const giftCardTopupPaymentMethods = _.sortBy(
      (() => {
        const allMethods = tillData?.tillAccess?.csBunit?.paymentMethodList || [];

        if (!giftCardPaymentSettings) {
          // null paymentsettings — show all methods just like wallet topup fallback
          return allMethods;
        }

        // Show only methods where topup === "Y" in giftCardPaymentSettings
        const topupAllowedIds = giftCardPaymentSettings.filter((s) => s.topup === "Y").map((s) => s.fin_paymentmethod_id);

        return allMethods.filter((pm) => topupAllowedIds.includes(pm.finPaymentmethodId));
      })(),
      ["sequenceNo", "name"]
    );

    const gcPageSize = 5;
    const gcTotalPages = Math.ceil(giftCardTopupPaymentMethods?.length / gcPageSize);
    const gcVisibleMethods =
      giftCardTopupPaymentMethods?.length <= gcPageSize
        ? giftCardTopupPaymentMethods
        : giftCardTopupPaymentMethods?.slice(giftCardTopupPaymentPage * gcPageSize, giftCardTopupPaymentPage * gcPageSize + gcPageSize);

    // Payments already added — read from walletPayments (same key requestPayment writes to)
    //const rawGiftCardPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];
    // const giftCardMatchedPayments = rawGiftCardPayments.map((payment) => {
    //   const matchedMethod = showPayments?.find((method) => method.finPaymentmethodId === payment.finPaymentmethodID);
    //   return {
    //     ...matchedMethod,
    //     ...payment,
    //     amount: Number(payment.amount).toFixed(2),
    //   };
    // });
    //const giftCardTotalPaid = giftCardMatchedPayments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

    // const giftCardAutoFillAmount = (topupAmt) => {
    //   if (!giftCardTopupPaymentMethod || !topupAmt || isNaN(topupAmt)) return;
    //   const remaining = parseFloat(topupAmt) - giftCardTotalPaid;
    //   if (remaining <= 0) return;
    //   const value = remaining.toString();
    //   const name = giftCardTopupPaymentMethod.name?.toLowerCase();
    //   if (name === "cash") setGiftCardTopupCashInput(value);
    //   else if (name === "card") setGiftCardTopupCardInput(value);
    //   else if (name === "upi") setGiftCardTopupUPIInput(value);
    //   else setGiftCardGenericInput(value); // ✅ generic
    // };

    const filteredGiftCards = availableGiftCards?.filter((card) => {
      const search = giftCardSearch.toLowerCase();
      return card?.card_no.toLowerCase().includes(search);
    });

    return (
      <>
        {/* Gift Card Selection Drawer */}
        <Drawer
          className="customerWalletDrawer"
          visible={isNewGiftCardFlag && showGiftCardSelection && !showGiftCardTopup}
          closable={false}
          maskClosable={false}
          onClose={closeAll}
          placement="right"
          width="62%"
          headerStyle={{ background: "white", borderBottom: "none" }}
          bodyStyle={{ padding: "0.5rem", paddingTop: 0, background: "white" }}
          style={{ borderRadius: "15px" }}
          title={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ fontSize: "1.2rem", fontWeight: "550", color: "#0F0718", paddingTop: "13px" }}>
                {/* <img src={giftVoucher || "/placeholder.svg"} style={{ height: "3.5vh", paddingRight: "5px", paddingLeft: "7px" }} alt="" /> */}
                Select Gift Card
              </div>
              <img src={Close || "/placeholder.svg"} onClick={closeAll} style={{ cursor: "pointer", width: "1.5vw" }} alt="Close" />
            </div>
          }
        >
          <Spin
            spinning={giftCardLoading}
            style={{
              marginTop: "40vh",
            }}
            tip="Loading Gift Cards..."
          >
            {!giftCardLoading && (
              <>
                {/* 🔍 Search Bar */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "16px",
                  }}
                >
                  <Input
                    placeholder="Search For Gift Card"
                    value={giftCardSearch}
                    onChange={(e) => setGiftCardSearch(e.target.value)}
                    style={{
                      width: "50%", // ✅ as requested
                      height: "36px",
                      borderRadius: "6px",
                    }}
                  />
                </div>

                {/* 📦 Scrollable Container */}
                <div
                  style={{
                    maxHeight: "80vh",
                    overflowX: "hidden",
                    overflowY: "auto",
                    paddingRight: "6px",
                  }}
                >
                  <Row gutter={[16, 16]}>
                    {filteredGiftCards.length > 0 ? (
                      filteredGiftCards.map((card) => (
                        <Col span={12} key={card?.cwr_giftcard_id}>
                          <div
                            style={{
                              height: "85px", // ✅ fixed height
                              border: "1px solid #e5e5e5",
                              borderRadius: "8px",
                              padding: "10px 12px",
                              background: "#fff",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.12)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
                            }}
                          >
                            {/* Left Content */}
                            <div style={{ overflow: "hidden" }}>
                              <div
                                style={{
                                  fontWeight: "600",
                                  fontSize: "0.9rem",
                                  color: "#0F0718",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "160px",
                                }}
                              >
                                {card?.card_no}
                              </div>

                              <div
                                style={{
                                  fontSize: "0.75rem",
                                  color: "#666",
                                }}
                              >
                                Current Balance: {card?.current_balance}
                              </div>
                            </div>

                            {/* ADD Button */}
                            <Button
                              size="small"
                              style={{
                                backgroundColor: "#2F3856",
                                color: "#fff",
                                borderRadius: "5px",
                                padding: "0 14px",
                                height: "30px",
                                fontSize: "0.75rem",
                                fontWeight: "500",
                                border: "none",
                              }}
                              onClick={() => {
                                setGiftCardNumber(card?.card_no);
                                setGiftCardBalance(card?.current_balance);
                                setShowGiftCardSelection(false);
                              }}
                            >
                              ADD
                            </Button>
                          </div>
                        </Col>
                      ))
                    ) : (
                      <Col span={24}>
                        <div
                          style={{
                            textAlign: "center",
                            color: "#999",
                            padding: "20px",
                          }}
                        >
                          No Gift Cards Found
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              </>
            )}
          </Spin>
        </Drawer>

        {/* First Drawer: Gift Card Number + PIN + Check Balance + Top-up Button */}
        <Drawer
          className="customerWalletDrawer"
          visible={isNewGiftCardFlag && !showGiftCardSelection && !showGiftCardTopup}
          closable={false}
          maskClosable={false}
          onClose={resetGiftCardState}
          placement="right"
          width="62%"
          headerStyle={{ background: "white", borderBottom: "none" }}
          bodyStyle={{ padding: "0.5rem", paddingTop: 0, background: "white" }}
          style={{ borderRadius: "15px" }}
          title={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ fontSize: "1.2rem", fontWeight: "550", color: "#0F0718", paddingTop: "13px" }}>
                {/* <img src={giftVoucher} style={{ height: "3vh", paddingLeft: "7px", cursor: "pointer", width: "2vw" }} alt="Gift Card" /> */}
                Add Money to Gift Card
              </div>
              <img src={Close || "/placeholder.svg"} onClick={resetGiftCardState} style={{ cursor: "pointer", width: "1.5vw" }} alt="Close" />
            </div>
          }
        >
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em", paddingTop: "1rem" }}>
            {/* Gift Card Number */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "0.4rem",
                  color: "#0F0718",
                  fontWeight: "550",
                  fontSize: "0.9rem",
                }}
              >
                Gift Card Number <span style={{ color: "#ff4d4f" }}>*</span>
              </label>
              <Input
                ref={giftCardNumberRef}
                value={giftCardNumber}
                onChange={(e) => {
                  setGiftCardNumber(e.target.value);
                  setGiftCardBalance(null);
                }}
                onFocus={() => setTimeout(() => giftCardNumberRef.current?.select(), 0)}
                placeholder="Enter Number"
                size="large"
                style={{ borderRadius: "6px", fontSize: "1rem" }}
                onPressEnter={() => giftCardPinRef.current?.focus()}
              />
            </div>

            {/* PIN (Optional) */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "0.4rem",
                  color: "#0F0718",
                  fontWeight: "550",
                  fontSize: "0.9rem",
                }}
              >
                PIN <span style={{ color: "#888", fontWeight: "400" }}>(Optional)</span>
              </label>
              <Input
                ref={giftCardPinRef}
                value={giftCardPin}
                onChange={(e) => setGiftCardPin(e.target.value)}
                placeholder="Enter Pin"
                type="password"
                size="large"
                style={{ borderRadius: "6px", fontSize: "1rem" }}
                onPressEnter={handleCheckGiftCardBalance}
              />
            </div>

            {/* Balance display */}
            {giftCardBalance !== null && (
              <div
                style={{
                  height: "3em",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "1rem",
                  backgroundColor: "#f0f0f0",
                  color: "#28a745",
                  fontWeight: "bold",
                  borderRadius: "12px",
                  marginBottom: "1.5rem",
                }}
              >
                Current Balance: {currSymbol}
                {parseFloat(giftCardBalance).toFixed(2)}
                {currSymbolRight}
              </div>
            )}

            {/* Info grid */}
            <Row gutter={[16, 16]} style={{ marginBottom: "2rem" }}>
              <Col span={12}>
                <div style={{ background: "#f9f9f9", borderRadius: "8px", padding: "1rem" }}>
                  <p style={{ margin: 0, color: "#666", fontSize: "0.85rem", fontWeight: "500" }}>Gift Card Balance</p>
                  <h3 style={{ margin: "0.4rem 0 0 0", color: "#0F0718", fontWeight: "700" }}>
                    {giftCardBalance !== null ? `${currSymbol}${parseFloat(giftCardBalance).toFixed(2)}${currSymbolRight}` : "0.00"}
                  </h3>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ background: "#f9f9f9", borderRadius: "8px", padding: "1rem" }}>
                  <p style={{ margin: 0, color: "#666", fontSize: "0.85rem", fontWeight: "500" }}>Bill Amount</p>
                  <h3 style={{ margin: "0.4rem 0 0 0", color: "#0F0718", fontWeight: "700" }}>
                    {currSymbol}
                    {billAmount}
                    {currSymbolRight}
                  </h3>
                </div>
              </Col>
            </Row>

            {/* Action Buttons */}
            <div style={{ display: "flex", gap: "1rem" }}>
              <Button
                size="large"
                loading={isCheckingBalance}
                onClick={handleCheckGiftCardBalance}
                style={{
                  flex: 1,
                  height: "50px",
                  backgroundColor: "#28a745",
                  borderColor: "#28a745",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "0.95rem",
                  borderRadius: "8px",
                }}
              >
                Check Balance
              </Button>
              <Button
                size="large"
                onClick={handleGiftCardTopup}
                style={{
                  flex: 1,
                  height: "50px",
                  backgroundColor: "#2F3856",
                  borderColor: "#2F3856",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "0.95rem",
                  borderRadius: "8px",
                }}
              >
                Top-up Gift Card
              </Button>
            </div>
          </div>
        </Drawer>

        {/* Second Drawer: Top-up Gift Card (matching wallet topup UI) */}
        <Drawer
          className="customerWalletDrawer"
          visible={isNewGiftCardFlag && showGiftCardTopup}
          closable={false}
          maskClosable={false}
          onClose={resetGiftCardTopup}
          placement="right"
          width="62%"
          headerStyle={{ background: "white", borderBottom: "none" }}
          bodyStyle={{ padding: "0.5rem", paddingTop: 0, background: "white" }}
          style={{ borderRadius: "15px" }}
          title={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ fontSize: "1.2rem", fontWeight: "550", color: "#0F0718", paddingTop: "13px" }}>
                <img src={giftVoucher || "/placeholder.svg"} style={{ height: "3.5vh", paddingRight: "5px", paddingLeft: "7px" }} alt="" />
                Top-up Gift Card
              </div>
              <img src={Close || "/placeholder.svg"} onClick={resetGiftCardTopup} style={{ cursor: "pointer", width: "1.5vw" }} alt="Close" />
            </div>
          }
        >
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            {/* Current Balance Banner */}
            <div
              style={{
                height: "3em",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "1rem",
                backgroundColor: "#f0f0f0",
                color: "#28a745",
                fontWeight: "bold",
                marginTop: "0.5rem",
                borderRadius: "12px",
              }}
            >
              Current Balance: {currSymbol}
              {giftCardBalance !== null ? parseFloat(giftCardBalance).toFixed(2) : "0.00"}
              {currSymbolRight}
            </div>

            <Card style={{ borderRadius: "8px", border: "none", background: "transparent" }}>
              <Row gutter={[10, 10]}>
                {/* Top-up Amount Input */}
                <Col span={24}>
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.3rem",
                        marginTop: "0.3rem",
                        color: "#0F0718",
                        fontWeight: "550",
                        fontSize: "0.9rem",
                      }}
                    >
                      Top-up Amount
                    </label>
                    <Input
                      ref={giftCardTopupInputRef}
                      size="large"
                      value={giftCardTopupAmount}
                      onChange={(e) => handleGiftCardTopupAmountChange(e.target.value)}
                      onFocus={() => setGiftCardTopupFocusedField("topupAmount")}
                      placeholder="0"
                      style={{
                        textAlign: "right",
                        fontSize: "1rem",
                        borderRadius: "6px",
                        border: giftCardTopupFocusedField === "topupAmount" ? "1.5px solid #2F3856" : "1px solid #d9d9d9",
                      }}
                    />
                  </div>
                </Col>

                {/* Payments added display */}
                <Col span={24}>
                  <Scrollbars style={{ height: "6vh" }}>
                    <Row style={{ fontSize: "1vw", textAlign: "center" }}>
                      <Col span={24}>
                        {giftCardMatchedPayments?.length > 0 ? (
                          giftCardMatchedPayments.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "2px 8px",
                                fontSize: "0.85rem",
                                color: "#0F0718",
                              }}
                            >
                              <span>{item.name}</span>
                              <span style={{ fontWeight: "600" }}>
                                {currSymbol}
                                {item.amount}
                                {currSymbolRight}
                              </span>
                            </div>
                          ))
                        ) : (
                          <p style={{ margin: "0", color: "#888" }}>No payments added</p>
                        )}
                      </Col>
                    </Row>
                  </Scrollbars>
                </Col>

                {/* Payment Method */}
                <Col span={24}>
                  <div>
                    <label style={{ display: "block", color: "#0F0718", fontWeight: "550", fontSize: "0.9rem" }}>Payment Method</label>
                    <div style={{ display: "flex", gap: 5 }}>
                      {gcVisibleMethods.map((pm) => (
                        <Button
                          key={pm.name}
                          type={giftCardTopupPaymentMethod?.name === pm.name ? "primary" : "default"}
                          onClick={() => {
                            setGiftCardTopupCashInput("");
                            setGiftCardTopupCardInput("");
                            setGiftCardTopupUPIInput("");
                            setGiftCardGenericInput("");
                            setGiftCardTopupPaymentMethod(pm);
                            if (pm.isBankTransfer === "Y") {
                              setBankTransferContext("giftcardtopup");
                              setIsBankTransferOpen(true);
                              setRedeemAmount("");
                              financialForm.resetFields();
                              setFinancialDocument(null);
                              return;
                            }
                            if (pm.isWallet === "Y") {
                              setWalletContext("giftcardtopup"); // new state to track context
                              setIswalletFlag(true);
                              fetchWalletData(true);
                              return;
                            }
                            setGiftCardTopupDenomKeyboard(pm.name.toLowerCase() === "cash");
                            setGiftCardTopupShowCardAmountInput(pm.name.toLowerCase() === "card" && posConfig?.transactionID === "Y" ? false : true);
                            giftCardTopupCardForm.resetFields();
                            localStorage.removeItem("cardPaymentDetails");
                            setGiftCardTopupFocusedField(null);
                            setTimeout(() => {
                              if (pm.name.toLowerCase() === "cash") {
                                giftCardTopupCashRef.current?.focus();
                                setGiftCardTopupFocusedField("cashInput");
                              } else if (pm.name.toLowerCase() === "card") {
                                giftCardTopupCardRef.current?.focus();
                                setGiftCardTopupFocusedField("cardInput");
                              } else if (pm.name.toLowerCase() === "upi") {
                                giftCardTopupUPIRef.current?.focus();
                                setGiftCardTopupFocusedField("upiInput");
                              }
                              giftCardAutoFillAmount(giftCardTopupAmount, pm);
                            }, 0);
                          }}
                          style={{
                            flex: 1,
                            height: "40px",
                            fontSize: "0.9rem",
                            backgroundColor: giftCardTopupPaymentMethod?.name === pm.name ? "#2F3856" : themeJSON.paymentMethodsBGColor || "#fff",
                            color: giftCardTopupPaymentMethod?.name === pm.name ? "#fff" : "#0F0718",
                            borderColor: themeJSON.paymentMethodsBGColor || "#e8e8e8",
                            borderRadius: "7px",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            {pm.name.toLowerCase() === "cash" ? (
                              <span>
                                {currenciesList?.[0]?.currSymbol || ""} {pm.name}
                              </span>
                            ) : pm.name.toLowerCase() === "card" ? (
                              <span>
                                <img src={cardType} style={{ height: "15px", marginRight: "5px" }} alt="card" />
                                {pm.name}
                              </span>
                            ) : pm.name.toLowerCase() === "upi" ? (
                              <span>
                                <img src={UPI} style={{ height: "15px", marginRight: "5px" }} alt="upi" />
                                {pm.name}
                              </span>
                            ) : (
                              <span>{pm.name}</span>
                            )}
                          </div>
                        </Button>
                      ))}
                      {giftCardTopupPaymentMethods?.length > gcPageSize && (
                        <Button
                          key="moreGCPayments"
                          onClick={() => {
                            setGiftCardTopupPaymentPage((prev) => (prev + 1) % gcTotalPages);
                          }}
                          style={{
                            flex: 1,
                            height: "40px",
                            fontSize: "0.9rem",
                            borderRadius: "7px",
                          }}
                        >
                          ...
                        </Button>
                      )}
                    </div>
                  </div>
                </Col>

                {/* Cash denomination keyboard */}
                {giftCardTopupPaymentMethod?.name?.toLowerCase() === "cash" && giftCardTopupDenomKeyboard ? (
                  <Col span={24}>
                    <div>
                      <label style={{ display: "block", marginBottom: "0.3rem", color: "#0F0718", fontWeight: "550", fontSize: "0.9rem" }}>Enter Amount</label>
                      <div>
                        <Row>
                          <Input
                            className="productSearch sm-payment-search totalQtyInput"
                            style={{
                              borderRadius: "5px",
                              height: "6vh",
                              margin: "0 0% 2.7% 0%",
                              textAlign: "right",
                              fontWeight: "500",
                              fontSize: "2.5em",
                              color: "#2F3856",
                              fontFamily: "Inter",
                              border: "1px solid #f0f0f0",
                              borderColor: "#fff",
                            }}
                            value={giftCardTopupCashInput}
                            onChange={(e) => setGiftCardTopupCashInput(e.target.value?.replace(/[^\d.]/g, ""))}
                            onFocus={() => setGiftCardTopupFocusedField("cashInput")}
                            ref={giftCardTopupCashRef}
                            placeholder="0"
                          />
                        </Row>
                        <Row style={{ padding: "0 0% 0 0.5%" }}>
                          <Col span={18}>
                            <Row gutter={[8, 5]} style={{ display: "flex", flexDirection: "row-reverse" }}>
                              {currenciesData?.map((currency) => (
                                <Col span={8} key={currency.value}>
                                  <button
                                    className="amt-dial-btn-market"
                                    onClick={() => handleGiftCardTopupDenomClick(currency.value)}
                                    disabled={currency.value === 999999}
                                    style={{
                                      color: currency.value !== 999999 ? "#0f0718" : "transparent",
                                      background: themeJSON?.keyBoardColor,
                                    }}
                                  >
                                    {currency.value}
                                  </button>
                                </Col>
                              ))}
                            </Row>
                          </Col>
                          <Col span={6}>
                            <Row style={{ padding: "0 0 2% 4%" }}>
                              <button className="amt-dial-btn-market" onClick={() => handleGiftCardTopupKeypad("x")} style={{ background: themeJSON?.keyBoardColor }}>
                                <img src={CancelArrow} alt="back space" width={25} height={15} />
                              </button>
                            </Row>
                            <Row style={{ padding: "0 0 2% 4%" }}>
                              <button
                                className="amt-dial-btn-market"
                                onClick={() => {
                                  setGiftCardTopupDenomKeyboard(false);
                                }}
                                style={{ background: themeJSON?.keyBoardColor }}
                              >
                                1,2,3...
                              </button>
                            </Row>
                            <Row style={{ padding: "0 0 0 4%" }}>
                              <button className="amt-dial-btn-market2" onClick={handleEnterTopup} style={{ background: themeJSON?.keyBoardColor }}>
                                Enter
                              </button>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                ) : giftCardTopupPaymentMethod?.name?.toLowerCase() === "cash" && !giftCardTopupDenomKeyboard ? (
                  // Numeric keyboard for cash
                  <Col span={24}>
                    <div>
                      <label style={{ display: "block", marginBottom: "0.3rem", color: "#0F0718", fontWeight: "550", fontSize: "0.9rem" }}>Enter Amount</label>
                      <div>
                        <Row>
                          <Input
                            className="productSearch sm-payment-search totalQtyInput"
                            style={{
                              borderRadius: "5px",
                              height: "6vh",
                              margin: "0 0% 2.7% 0%",
                              textAlign: "right",
                              fontWeight: "500",
                              fontSize: "2.5em",
                              color: "#2F3856",
                              fontFamily: "Inter",
                              border: "1px solid #f0f0f0",
                              borderColor: "#fff",
                            }}
                            value={giftCardTopupCashInput}
                            onChange={(e) => setGiftCardTopupCashInput(e.target.value?.replace(/[^\d.]/g, ""))}
                            onFocus={() => setGiftCardTopupFocusedField("cashInput")}
                            ref={giftCardTopupCashRef}
                            placeholder="0"
                          />
                        </Row>
                        <Row style={{ padding: "0 0% 0 0.5%" }} gutter={[8, 6]}>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("1")}>
                              1
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("2")}>
                              2
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("3")}>
                              3
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("x")}>
                              <img src={CancelArrow} alt="back space" width={25} height={15} />
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("4")}>
                              4
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("5")}>
                              5
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("6")}>
                              6
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => setGiftCardTopupDenomKeyboard(true)}>
                              1,2,3...
                            </button>
                          </Col>
                          <Col span={18}>
                            <Row gutter={[8, 6]}>
                              <Col span={8}>
                                <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("7")}>
                                  7
                                </button>
                              </Col>
                              <Col span={8}>
                                <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("8")}>
                                  8
                                </button>
                              </Col>
                              <Col span={8}>
                                <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("9")}>
                                  9
                                </button>
                              </Col>
                              <Col span={8}>
                                <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("0")}>
                                  0
                                </button>
                              </Col>
                              <Col span={8}>
                                <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad(".")}>
                                  .
                                </button>
                              </Col>
                              <Col span={8}>
                                <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("clear")}>
                                  Clear
                                </button>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market2" style={{ background: themeJSON?.keyBoardColor }} onClick={handleEnterTopup}>
                              Enter
                            </button>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                ) : // )
                //  : giftCardTopupPaymentMethod?.name?.toLowerCase() === "card" && posConfig?.transactionID === "Y" && !giftCardTopupShowCardAmountInput ? (
                //   <Col span={24}>
                //     <Form layout="vertical" form={giftCardTopupCardForm}>
                //       <Row>
                //         <Col span={10} style={{ paddingRight: "1vw" }}>
                //           <Row>
                //             <Col span={20}>
                //               <Form.Item
                //                 style={{ marginBottom: "10px" }}
                //                 name="transactionId"
                //                 rules={[{ required: posConfig?.transactionID_mandatory === "Yes", message: "Please enter Transaction ID" }]}
                //                 label={<span style={{ color: "#000", fontSize: "1rem", fontWeight: "500" }}>Transaction ID</span>}
                //               >
                //                 <Input
                //                   id="gcTransactionId"
                //                   placeholder="Transaction ID"
                //                   size="large"
                //                   onPressEnter={(e) => e.preventDefault()}
                //                   allowClear={false}
                //                   style={{ borderRadius: "6px", padding: "8px 12px" }}
                //                   onFocus={() => {
                //                     setGiftCardTopupInputFocused("transactionId");
                //                     setGiftCardTopupLayoutName("default");
                //                   }}
                //                 />
                //               </Form.Item>
                //             </Col>
                //             <Col span={20}>
                //               {posConfig?.authorizationCode === "Y" && (
                //                 <Form.Item
                //                   style={{ marginBottom: "10px" }}
                //                   name="authorization"
                //                   rules={[{ required: posConfig?.authorizationCode_mandatory === "Yes", message: "Please enter Authorization Code" }]}
                //                   label={<span style={{ color: "#000", fontSize: "1rem", fontWeight: "500" }}>Authorization Code</span>}
                //                 >
                //                   <Input
                //                     id="gcAuthorization"
                //                     placeholder="Authorization Code"
                //                     size="large"
                //                     onPressEnter={(e) => e.preventDefault()}
                //                     allowClear={false}
                //                     style={{ borderRadius: "6px", padding: "8px 12px" }}
                //                     onFocus={() => {
                //                       setGiftCardTopupInputFocused("authorization");
                //                       setGiftCardTopupLayoutName("default");
                //                     }}
                //                   />
                //                 </Form.Item>
                //               )}
                //             </Col>
                //             <Col span={20}>
                //               {posConfig?.cardType === "Y" && (
                //                 <Form.Item
                //                   style={{ marginBottom: "10px" }}
                //                   name="cardType"
                //                   rules={[{ required: posConfig?.cardType_mandatory === "Yes", message: "Please select Card Type" }]}
                //                   label={<span style={{ color: "#000", fontSize: "1rem", fontWeight: "500" }}>Card Type</span>}
                //                 >
                //                   <Select className="selecItem" placeholder={<span className="cartSelect">Card Type</span>} size="large" style={{ borderRadius: "6px" }}>
                //                     <Option className="cartOption" key="VI" value="VI">
                //                       Visa - VI
                //                     </Option>
                //                     <Option className="cartOption" key="MA" value="MA">
                //                       Master Card - MA
                //                     </Option>
                //                     <Option className="cartOption" key="RU" value="RU">
                //                       Rupay - RU
                //                     </Option>
                //                     <Option className="cartOption" key="AM" value="AM">
                //                       Amex - AM
                //                     </Option>
                //                     <Option className="cartOption" key="ME" value="ME">
                //                       Maestro - ME
                //                     </Option>
                //                   </Select>
                //                 </Form.Item>
                //               )}
                //             </Col>
                //             <Col span={20}>
                //               {posConfig?.CardNumber === "Y" && (
                //                 <Form.Item
                //                   style={{ marginBottom: "10px" }}
                //                   name="cardNumber"
                //                   rules={[
                //                     { required: posConfig?.CardNumber_mandatory === "Yes", message: "Please enter Card Number" },
                //                     { pattern: /^\d{4}$/, message: "Card Number must be exactly 4 digits" },
                //                   ]}
                //                   label={<span style={{ color: "#000", fontSize: "1rem", fontWeight: "500" }}>Card Number (Last 4 Digits)</span>}
                //                 >
                //                   <Input
                //                     id="gcCardNumber"
                //                     placeholder="Enter Number"
                //                     size="large"
                //                     onPressEnter={(e) => e.preventDefault()}
                //                     allowClear={false}
                //                     maxLength={4}
                //                     style={{ borderRadius: "6px", padding: "8px 12px" }}
                //                     onFocus={() => {
                //                       setGiftCardTopupInputFocused("cardNumber");
                //                       setGiftCardTopupLayoutName("numbers");
                //                     }}
                //                   />
                //                 </Form.Item>
                //               )}
                //             </Col>
                //           </Row>
                //         </Col>
                //         <Col span={14}>
                //           <Row gutter={[8, 6]}>
                //             <Keyboard
                //               theme="hg-theme-default aprvl"
                //               style={{ marginTop: "5px" }}
                //               onChangeAll={(inputs) => {
                //                 giftCardTopupCardForm.setFieldsValue(inputs);
                //               }}
                //               inputName={giftCardTopupInputFocused}
                //               keyboardRef={(r) => (giftCardTopupKeyboardRef.current = r)}
                //               onKeyPress={(button) => {
                //                 const currentValue = giftCardTopupCardForm.getFieldValue(giftCardTopupInputFocused) || "";
                //                 if (giftCardTopupInputFocused === "cardNumber") {
                //                   if (button.match(/^\d$/)) {
                //                     if (currentValue.length < 4) {
                //                       giftCardTopupCardForm.setFieldsValue({ cardNumber: currentValue + button });
                //                     }
                //                     return;
                //                   } else if (button === "{backspace}") {
                //                     giftCardTopupCardForm.setFieldsValue({ [giftCardTopupInputFocused]: currentValue.slice(0, -1) });
                //                   }
                //                   return;
                //                 }
                //                 if (button === "{shift}" || button === "{lock}") {
                //                   setGiftCardTopupLayoutName((prev) => (prev === "default" ? "shift" : "default"));
                //                 } else if (button === "{number}" || button === "{numbers}") {
                //                   setGiftCardTopupLayoutName("numbers");
                //                 } else if (button === "{small}") {
                //                   setGiftCardTopupLayoutName("shift");
                //                 } else if (button === "{caps}") {
                //                   setGiftCardTopupLayoutName("default");
                //                 } else if (button === "{space}") {
                //                   giftCardTopupCardForm.setFieldsValue({ [giftCardTopupInputFocused]: `${currentValue} ` });
                //                 } else if (button === "{backspace}") {
                //                   giftCardTopupCardForm.setFieldsValue({ [giftCardTopupInputFocused]: currentValue.slice(0, -1) });
                //                 } else if (button !== "{enter}" && button !== "{shift}" && button !== "{caps}" && button !== "{numbers}") {
                //                   giftCardTopupCardForm.setFieldsValue({ [giftCardTopupInputFocused]: currentValue + button });
                //                 }
                //               }}
                //               layoutName={giftCardTopupLayoutName}
                //               display={{
                //                 "{abc}": "ABC",
                //                 "{smileys}": "\uD83D\uDE03",
                //                 "{back}": "Enter",
                //                 "{numbers}": "123",
                //                 "{number}": "123",
                //                 "{bksp}": "backspace",
                //                 "{backspace}": "⌫",
                //                 "{shift}": "⇧",
                //                 "{tab}": "tab",
                //                 "{lock}": "lock",
                //                 "{enter}": "Enter",
                //                 "{space}": "Space",
                //                 "{caps}": "ABC",
                //                 "{small}": "abc",
                //               }}
                //               layout={{
                //                 shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                //                 numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                //                 number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                //                 default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
                //               }}
                //             />
                //             <Col span={20} pull={2} push={2} style={{ padding: "3% 0", marginTop: "1%" }}>
                //               <Button
                //                 htmlType="button"
                //                 onClick={() => {
                //                   const cardValues = giftCardTopupCardForm.getFieldsValue();
                //                   localStorage.setItem("cardPaymentDetails", JSON.stringify(cardValues));
                //                   giftCardTopupCardForm
                //                     .validateFields()
                //                     .then(() => {
                //                       setGiftCardTopupShowCardAmountInput(true);
                //                       setGiftCardTopupFocusedField("cardInput");
                //                       setTimeout(() => giftCardTopupCardRef.current?.focus(), 0);
                //                     })
                //                     .catch(() => {
                //                       message.error("Please fill all required fields");
                //                     });
                //                 }}
                //                 style={{
                //                   backgroundColor: "#2F3856",
                //                   color: "#fff",
                //                   width: "100%",
                //                   fontSize: "1rem",
                //                   textAlign: "center",
                //                   fontWeight: "400",
                //                   borderRadius: "7px",
                //                   height: "40px",
                //                 }}
                //               >
                //                 Submit
                //               </Button>
                //             </Col>
                //           </Row>
                //         </Col>
                //       </Row>
                //     </Form>
                //   </Col>
                giftCardTopupPaymentMethod?.name?.toLowerCase() === "card" ? (
                  // Card amount input (after card details are submitted)
                  <Col span={24}>
                    <div>
                      <label style={{ display: "block", marginBottom: "0.3rem", color: "#0F0718", fontWeight: "550", fontSize: "0.9rem" }}>Enter Amount</label>
                      <Input
                        ref={giftCardTopupCardRef}
                        className="productSearch sm-payment-search totalQtyInput"
                        style={{ borderRadius: "5px", height: "6vh", textAlign: "right", fontWeight: "500", fontSize: "1.5em", border: "1px solid #f0f0f0" }}
                        value={giftCardTopupCardInput}
                        onChange={(e) => setGiftCardTopupCardInput(e.target.value?.replace(/[^\d.]/g, ""))}
                        onFocus={() => setGiftCardTopupFocusedField("cardInput")}
                        placeholder="0"
                      />
                      <Row style={{ padding: "0.5rem 0" }} gutter={[8, 6]}>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("1")}>
                            1
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("2")}>
                            2
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("3")}>
                            3
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("x")}>
                            <img src={CancelArrow} alt="back space" width={25} height={15} />
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("4")}>
                            4
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("5")}>
                            5
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("6")}>
                            6
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("clear")}>
                            Clear
                          </button>
                        </Col>
                        <Col span={18}>
                          <Row gutter={[8, 6]}>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("7")}>
                                7
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("8")}>
                                8
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("9")}>
                                9
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("0")}>
                                0
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad(".")}>
                                .
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("00")}>
                                00
                              </button>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market2" style={{ background: themeJSON?.keyBoardColor }} onClick={handleEnterTopup}>
                            Enter
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ) : giftCardTopupPaymentMethod?.name?.toLowerCase() === "upi" ? (
                  // UPI amount input
                  <Col span={24}>
                    <div>
                      <label style={{ display: "block", marginBottom: "0.3rem", color: "#0F0718", fontWeight: "550", fontSize: "0.9rem" }}>Enter Amount</label>
                      <Input
                        ref={giftCardTopupUPIRef}
                        className="productSearch sm-payment-search totalQtyInput"
                        style={{ borderRadius: "5px", height: "6vh", textAlign: "right", fontWeight: "500", fontSize: "1.5em", border: "1px solid #f0f0f0" }}
                        value={giftCardTopupUPIInput}
                        onChange={(e) => setGiftCardTopupUPIInput(e.target.value?.replace(/[^\d.]/g, ""))}
                        onFocus={() => setGiftCardTopupFocusedField("upiInput")}
                        placeholder="0"
                      />
                      <Row style={{ padding: "0.5rem 0" }} gutter={[8, 6]}>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("1")}>
                            1
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("2")}>
                            2
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("3")}>
                            3
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("x")}>
                            <img src={CancelArrow} alt="back space" width={25} height={15} />
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("4")}>
                            4
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("5")}>
                            5
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("6")}>
                            6
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("clear")}>
                            Clear
                          </button>
                        </Col>
                        <Col span={18}>
                          <Row gutter={[8, 6]}>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("7")}>
                                7
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("8")}>
                                8
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("9")}>
                                9
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("0")}>
                                0
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad(".")}>
                                .
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardTopupKeypad("00")}>
                                00
                              </button>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market2" style={{ background: themeJSON?.keyBoardColor }} onClick={handleEnterTopup}>
                            Enter
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ) : giftCardTopupPaymentMethod && !["cash", "card", "upi"].includes(giftCardTopupPaymentMethod?.name?.toLowerCase()) ? (
                  <Col span={24}>
                    <div style={giftCardTopupPaymentMethod?.isWallet === "Y" || giftCardTopupPaymentMethod?.isBankTransfer === "Y" ? { pointerEvents: "none", opacity: 0.4 } : {}}>
                      <label style={{ display: "block", marginBottom: "0.3rem", color: "#0F0718", fontWeight: "550", fontSize: "0.9rem" }}>Enter Amount</label>
                      <Input
                        size="large"
                        value={giftCardGenericInput}
                        onChange={(e) => setGiftCardGenericInput(e.target.value.replace(/[^\d.]/g, ""))}
                        placeholder="0"
                        style={{ textAlign: "right", fontSize: "1rem", borderRadius: "6px", marginBottom: "1rem" }}
                      />
                      <Row style={{ padding: "0 1% 0 1%" }} gutter={[8, 6]}>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("1")}>
                            1
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("2")}>
                            2
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("3")}>
                            3
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("x")}>
                            <img src={CancelArrow} alt="back space" width={25} height={15} />
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("4")}>
                            4
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("5")}>
                            5
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("6")}>
                            6
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("clear")}>
                            Clear
                          </button>
                        </Col>
                        <Col span={18}>
                          <Row gutter={[8, 6]}>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("7")}>
                                7
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("8")}>
                                8
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("9")}>
                                9
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("0")}>
                                0
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount("00")}>
                                00
                              </button>
                            </Col>
                            <Col span={8}>
                              <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGiftCardGenericAmount(".")}>
                                .
                              </button>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={6}>
                          {/* ✅ Just reuse handleEnterTopup — currentPaymentInput now picks up giftCardGenericInput */}
                          <button className="amt-dial-btn-market2" style={{ background: themeJSON?.keyBoardColor }} onClick={handleEnterTopup}>
                            Enter
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ) : null}
              </Row>
            </Card>
          </div>
        </Drawer>
      </>
    );
  };

  const createExchangeCartObj = () => {
    return {
      items: [],
      couponInput: [],
      advancePayment: 0,
      total: 0,
      tax: 0,
      discount: 0,
      paid: 0,
      change: 0,
      totalQty: 0,
      roundOff: 0,
      payments: [],
      redemptionPoints: 0,
      accumulationPoints: 0,
      creditAmount: 0,
      docType: "Invoice",
      sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
      referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
      giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      customer: selectedReturnOrder?.cwrB2cCustomer || defaultCustomer,
      salesRepId: null,
      cardPaymentData: {},
      documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
      userName: userData.user,
      tillName: tillValue?.name,
      subTotal: 0,
      itemsSummery: {},
      amountInWords: "",
      groupedItemsByTaxRate: {},
      serviceCharge: 0,
      tcs: 0,
      tip: 0,
      deiveryCharge: 0,
      packingCharge: 0,
      others: 0,
      refundAmount: 0,
    };
  };

  const handleDenominationClick = (value) => {
    const sanitizedValue = Number.parseFloat(value.toString().replace(/[^0-9.]/g, "")) || 0;
    if (focusedInputField === "topupAmount") {
      const currentValue = Number.parseFloat(topupAmount) || 0;
      const newValue = (currentValue + sanitizedValue).toFixed(2);
      setTopupAmount(newValue);
    } else if (focusedInputField === "currentCashInput") {
      const currentValue = Number.parseFloat(currentCashInput) || 0;
      const newValue = (currentValue + sanitizedValue).toFixed(2);
      setCurrentCashInput(newValue);
    } else if (focusedInputField === "currentCardInput") {
      const currentValue = Number.parseFloat(currentCardInput) || 0;
      const newValue = (currentValue + sanitizedValue).toFixed(2);
      setCurrentCardInput(newValue);
    } else if (focusedInputField === "currentUPIInput") {
      const currentValue = Number.parseFloat(currentUPIInput) || 0;
      const newValue = (currentValue + sanitizedValue).toFixed(2);
      setCurrentUPIInput(newValue);
    }
    setDenaminationsKeyboard(true);
  };

  const handleCustomerSearch = (value) => {
    setCustomerSearchValue(value);
  };

  const filteredCustomers =
    Array.isArray(customersData) && customersData.length > 0
      ? customersData.filter(
          (customer) =>
            customer?.name?.toLowerCase().includes(customerSearchValue.toLowerCase()) ||
            customer?.phone?.includes(customerSearchValue) ||
            customer?.id?.toLowerCase().includes(customerSearchValue.toLowerCase())
        )
      : cart?.customer
        ? [cart.customer]
        : [];

  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
  };

  const handleChangeCustomer = () => {
    setSelectedCustomer(null);
    setCustomerSearchValue("");
    setShowTopupModal(false);
    setShowTransactionsModal(false);
  };

  const handleTopupWallet = () => {
    const initialPayments = _.sortBy(filteredPaymentMethods, "sequenceNo");

    setShowTopupModal(true);
    setShowTransactionsModal(false);
    setShowRefundModal(false);

    setShowPayments(initialPayments);

    // ✅ Select first payment method like Refund wallet
    if (initialPayments.length > 0) {
      const firstMethod = initialPayments[0];

      setSelectedPaymentMethod(firstMethod);

      setDenaminationsKeyboard(firstMethod.name?.toLowerCase() === "cash");
    } else {
      setSelectedPaymentMethod({});
    }

    setPaymentPage(0); // reset pagination if you are using the "..." paging
  };

  const handleWalletOtpVerify = async () => {
    const currSymbol = currenciesList?.[0]?.symbolRightSide === "N" ? currenciesList[0].currSymbol : "";
    const currSymbolRight = currenciesList?.[0]?.symbolRightSide === "Y" ? currenciesList[0].currSymbol : "";
    const otpValue = walletOtp.join("");

    try {
      const validOtpResponse = await validOtp(cart.customer.cwrCustomerId, otpValue, walletOtpAmount, "");

      const status = validOtpResponse?.data?.data?.validOtp?.status;

      if (status === "200") {
        const amountValue = walletOtpAmount;
        const walletBalance = parseFloat(selectedCustomer[0]?.currentBalance || 0);

        const tillData = JSON.parse(localStorage.getItem("tillData")) || {};
        const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;

        // 🔵 ORIGINAL WALLET FLOW (UNCHANGED)
        const payload = {
          bunitId,
          customerId: cart.customer.cwrCustomerId,
          trxType: "WD",
          trxValue: amountValue,
          tillId: tillData?.tillAccess.cwrTill.cwrTillID,
        };

        const response = await upsertWalletTransactionService(payload);

        if (response?.status !== "200") {
          message.error("Wallet deduction failed");
          return;
        }

        const updatedCustomer = {
          ...selectedCustomer[0],
          currentBalance: walletBalance - amountValue,
        };

        setSelectedCustomer([updatedCustomer]);
        if (walletContext === "giftcardtopup") {
          await requestPayment(giftCardTopupPaymentMethod, amountValue.toFixed(2), undefined, true);
          setRedeemAmount("");
          setIswalletFlag(false);
          setShowWalletOtpModal(false);
          setWalletOtp(Array(6).fill(""));
          setWalletContext(null);

          const topupTotal = parseFloat(giftCardTopupAmount).toFixed(2);
          const updatedTotalPaid = (giftCardTotalPaid + amountValue).toFixed(2);
          if (parseFloat(updatedTotalPaid) >= parseFloat(topupTotal)) {
            await finalizeGiftCardTopup(topupTotal);
          } else {
            const remaining = (parseFloat(topupTotal) - parseFloat(updatedTotalPaid)).toFixed(2);
            message.success(`Wallet payment of ${currSymbol}${amountValue.toFixed(2)}${currSymbolRight} added. Remaining: ${currSymbol}${remaining}${currSymbolRight}`);
          }
        } else {
          requestPayment({ ...selectedPaymentMethod, walletAlreadyDeducted: true }, amountValue.toFixed(2));

          setRedeemAmount("");
          setIswalletFlag(false);
          setShowWalletOtpModal(false);
          setWalletOtp(Array(6).fill(""));
        }
      } else {
        setWalletOtpError(true);
      }
    } catch (err) {
      message.error("Invalid OTP");
    }
  };

  const handleViewTransactions = () => {
    setShowTransactionsModal(true);
    setShowTopupModal(false);
  };

  const formatOnBlur = () => {
    if (!topupAmount) return;
    setTopupAmount(parseFloat(topupAmount).toFixed(pricePrecision));
  };

  const handleTopupAmountChange = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, "");
    const parts = sanitizedValue.split(".");

    if (parts.length > 2) return;
    if (parts.length === 2 && parts[1].length > 2) return;

    const numericValue = parseFloat(sanitizedValue || 0);

    // 🔥 Refund validation
    if (showRefundModal) {
      const balance = selectedCustomer?.[0]?.currentBalance || 0;

      // Block if balance zero or negative
      if (balance <= 0) {
        message.error("No balance available for refund");
        return;
      }

      // Block if refund exceeds balance
      if (numericValue > balance) {
        message.warning(`Maximum refundable amount is ${balance.toFixed(2)}`);
        return;
      }
    }

    setTopupAmount(sanitizedValue);

    // 🟢 if user cleared input → clear autofill
    if (sanitizedValue === "") {
      setCurrentCashInput("");
      setCurrentCardInput("");
      setCurrentUPIInput("");
      setRedeemAmount("");
      setDynamicPaymentInput("");
      return;
    }

    autoFillEnterAmount(sanitizedValue);
  };

  const rawWalletPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];

  const handleProcessTopup = async () => {
    if (!topupAmount || Number.parseFloat(topupAmount) <= 0) {
      message.error(`${messages.info.valid_amount}`);
      return;
    }

    setIsProcessingTopup(true);

    try {
      const amount = Number.parseFloat(topupAmount);
      const newTransaction = {
        id: (selectedCustomer?.transactions?.length || 0) + 1,
        date: new Date().toISOString().split("T")[0],
        time: new Date().toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        type: "Credit",
        amount: amount,
        description: `Wallet Top-up via ${selectedPaymentMethod.name}`,
        reference: `TXN${String(Date.now()).slice(-3)}`,
        balance: (selectedCustomer?.currentBalance || 0) + amount,
      };

      const updatedCustomer = {
        ...selectedCustomer,
        currentBalance: (selectedCustomer?.currentBalance || 0) + amount,
        lastTransaction: new Date().toISOString().split("T")[0],
        transactions: [newTransaction, ...(selectedCustomer?.transactions || [])],
      };

      // Only update customersData if setCustomersData function is available
      if (typeof setCustomersData === "function") {
        if (Array.isArray(customersData)) {
          const updatedCustomers = customersData.map((customer) => {
            if (customer?.id === selectedCustomer?.id) {
              return updatedCustomer;
            }
            return customer;
          });
          setCustomersData(updatedCustomers);
        } else {
          // If customersData is not an array, update it directly
          setCustomersData(updatedCustomer);
        }
      }

      setSelectedCustomer(updatedCustomer);

      message.success(
        `Wallet topped up successfully! Added ${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}${amount.toFixed(2)}${
          currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
        }`
      );

      setTimeout(() => {
        setIsProcessingTopup(false);
        setShowTopupModal(false);
        setTopupAmount("");
        setSelectedPaymentMethod("Cash");
      }, 1500);
    } catch (error) {
      console.error("Topup error:", error);
      message.error(`${messages.errors.payments.wallet_topup_failed}`);
      setIsProcessingTopup(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleWalletRefund = () => {
    setShowRefundModal(true);
    setShowTopupModal(false);

    // Use the same walletPreferences-filtered list that gets rendered
    const walletPreferences = (() => {
      try {
        const raw = tillData?.tillAccess?.walletPreferences;
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed[0] : parsed;
      } catch {
        return null;
      }
    })();

    const walletPaymentSettings = walletPreferences?.paymentsettings || null;
    const allMethods = tillData?.tillAccess?.csBunit?.paymentMethodList || [];

    let refundMethods;
    if (!walletPaymentSettings) {
      // No paymentsettings — fall back to original filter
      refundMethods = _.sortBy(
        allMethods.filter((pm) => pm.isReturns === "Y" && pm.isWallet !== "Y"),
        ["sequenceNo", "name"]
      );
    } else {
      // Filter by refund === "Y" in paymentsettings — same logic as paymentMethodForTopup
      const refundAllowedIds = walletPaymentSettings.filter((s) => s.refund === "Y").map((s) => s.fin_paymentmethod_id);
      refundMethods = _.sortBy(
        allMethods.filter((pm) => refundAllowedIds.includes(pm.finPaymentmethodId)),
        ["sequenceNo", "name"]
      );
    }

    if (refundMethods.length > 0) {
      const firstMethod = refundMethods[0];
      setSelectedPaymentMethod(firstMethod);
      setDenaminationsKeyboard(firstMethod.name?.toLowerCase() === "cash");
    } else {
      setSelectedPaymentMethod({});
      setDenaminationsKeyboard(false);
    }

    // Focus amount input
    setTimeout(() => {
      topupInputRef.current?.focus();
      setFocusedInputField("topupAmount");
    }, 50);
  };

  const handleTotalQty = (value) => {
    let currentValue =
      focusedInputField === "topupAmount"
        ? topupAmount
        : selectedPaymentMethod.name === "Cash"
          ? currentCashInput
          : selectedPaymentMethod.name === "Card"
            ? currentCardInput
            : currentUPIInput;

    if (value === "clear") {
      if (focusedInputField === "topupAmount") {
        setTopupAmount("");
      } else if (selectedPaymentMethod.name === "Cash") {
        setCurrentCashInput("");
      } else if (selectedPaymentMethod.name === "Card") {
        setCurrentCardInput("");
      } else {
        setCurrentUPIInput("");
      }
    } else if (value === "x") {
      if (focusedInputField === "topupAmount") {
        setTopupAmount(currentValue.slice(0, -1) || "");
      } else if (selectedPaymentMethod.name === "Cash") {
        setCurrentCashInput(currentValue.slice(0, -1) || "");
      } else if (selectedPaymentMethod.name === "Card") {
        setCurrentCardInput(currentValue.slice(0, -1) || "");
      } else {
        setCurrentUPIInput(currentValue.slice(0, -1) || "");
      }
    } else {
      const newValue = currentValue + value;
      const sanitizedValue = newValue.replace(/[^0-9.]/g, "");
      const parts = sanitizedValue.split(".");
      if (parts.length > 2 || (parts.length === 2 && parts[1].length > 2)) {
        return;
      }
      if (focusedInputField === "topupAmount") {
        setTopupAmount(sanitizedValue);
      } else if (selectedPaymentMethod.name === "Cash") {
        setCurrentCashInput(sanitizedValue);
      } else if (selectedPaymentMethod.name === "Card") {
        setCurrentCardInput(sanitizedValue);
      } else {
        setCurrentUPIInput(sanitizedValue);
      }
    }
  };

  const enterTotalQty = async () => {
    if (!selectedPaymentMethod || !selectedPaymentMethod.name) {
      message.warning("Please select a payment method to complete the payment");
      return;
    }

    if (typeof setCart !== "function") {
      console.error("setCart is not a function. Cannot update cart.");
      message.error(`${messages.errors.payments.configuration_payment_failed}`);
      return;
    }

    const currentInput =
      selectedPaymentMethod.name === "Cash"
        ? currentCashInput
        : selectedPaymentMethod.name === "Card"
          ? currentCardInput
          : selectedPaymentMethod.name === "UPI"
            ? currentUPIInput
            : dynamicPaymentInput; // 🔥 for NEFT / RTGS / others

    if (!currentInput || Number.parseFloat(currentInput) <= 0) {
      message.error(`${messages.info.valid_amount}`);
      return;
    }

    if (!topupAmount || Number.parseFloat(topupAmount) <= 0) {
      message.error(`${messages.info.valid_topup_amount}`);
      return;
    }

    const paymentAmount = Number.parseFloat(currentInput).toFixed(2);
    const topupTotal = Number.parseFloat(topupAmount).toFixed(2);
    const newCashTendered = (Number.parseFloat(cashTendered) || 0) + Number.parseFloat(paymentAmount);

    // Calculate total payments from matchedPayments
    const totalPayments = matchedPayments.reduce((sum, payment) => sum + Number.parseFloat(payment.amount || 0), 0).toFixed(2);

    // Check if the new payment amount exceeds the top-up amount
    if (Number.parseFloat(totalPayments) + Number.parseFloat(paymentAmount) > topupTotal) {
      message.error(`${selectedPaymentMethod.name} ${messages.warnings.payment.payment_multiple_check_topup} ${topupTotal - totalPayments}`);
      return;
    }

    setIsProcessingTopup(true);

    try {
      // Validate denomination for cash payments
      if (selectedPaymentMethod.name === "Cash") {
        const filteredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
        if (filteredCurrencies.length > 0) {
          const result = modulo(Number.parseFloat(currentInput || 0), filteredCurrencies[0]?.value || 1);
          if (result !== 0) {
            message.warning(`${messages.warnings.payment.payment_multiple_check} ${filteredCurrencies[0]?.value}`);
            setIsProcessingTopup(false);
            return;
          }
        }
      }
      // Card payment popup logic
      if (selectedPaymentMethod?.name?.toLowerCase() === "card" && selectedPaymentMethod?.integratedPayment && posConfig?.show_card_payment_popup === "Y") {
        if (isValidAmount(paymentAmount)) {
          setIsProcessingTopup(false);
          setShowCardPaymnteModal(true);
          return;
        } else {
          message.warning("Kindly enter the amount before proceeding");
          setIsProcessingTopup(false);
          return;
        }
      } else if (selectedPaymentMethod?.name?.toLowerCase() === "card" && !selectedPaymentMethod?.integratedPayment && posConfig?.show_card_payment_popup === "Y") {
        if (isValidAmount(paymentAmount)) {
          setPaymentType("manual");
          setCardPaymnetError(true);
          setIsProcessingTopup(false);
          setShowCardPaymnteModal(true);
          return;
        } else {
          message.warning("Kindly enter the amount before proceeding");
          setIsProcessingTopup(false);
          return;
        }
      }
      // Call requestPayment with the payment method object
      await requestPayment(selectedPaymentMethod, paymentAmount, undefined, true);

      // Persist cart to localStorage
      localStorage.setItem("cartObj", JSON.stringify(cart));

      // Recalculate total payments after adding the new payment
      const updatedTotalPayments = (Number.parseFloat(totalPayments) + Number.parseFloat(paymentAmount)).toFixed(2);

      // Create new transaction
      const newTransaction = {
        id: (selectedCustomer?.transactions?.length || 0) + 1,
        date: new Date().toISOString().split("T")[0],
        time: new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true }),
        type: "Credit",
        amount: Number.parseFloat(paymentAmount),
        description: `Wallet Top-up via ${selectedPaymentMethod.name}`,
        reference: `TXN${String(Date.now()).slice(-3)}`,
        balance: (selectedCustomer?.currentBalance || 0) + Number.parseFloat(paymentAmount),
      };

      // Update customer data
      const updatedCustomer = {
        ...selectedCustomer,
        currentBalance: (selectedCustomer?.currentBalance || 0) + Number.parseFloat(paymentAmount),
        lastTransaction: new Date().toISOString().split("T")[0],
        transactions: [newTransaction, ...(selectedCustomer?.transactions || [])],
      };

      if (typeof setCustomersData === "function") {
        if (Array.isArray(customersData)) {
          const updatedCustomers = customersData.map((customer) => (customer?.id === selectedCustomer?.id ? updatedCustomer : customer));
          setCustomersData(updatedCustomers);
        } else {
          setCustomersData(updatedCustomer);
        }
      }

      setSelectedCustomer(updatedCustomer);
      setCurrentCashInput("");
      setCurrentCardInput("");
      setCurrentUPIInput("");
      setCashTendered(newCashTendered);
      setRedeemAmount("");
      setDynamicPaymentInput("");
      const remainingAmount = Number.parseFloat(topupTotal) - Number.parseFloat(updatedTotalPayments);

      if (remainingAmount > 0) {
        autoFillEnterAmount(remainingAmount.toString());
      } else {
        setCurrentCashInput("");
        setCurrentCardInput("");
        setCurrentUPIInput("");
        setDynamicPaymentInput("");
      }
      // Check if total payments equal topupAmount
      if (Number.parseFloat(updatedTotalPayments) >= Number.parseFloat(topupTotal)) {
        const customerBalance = selectedCustomer?.[0]?.currentBalance || 0;
        if (showRefundModal) {
          const refundAmount = Number.parseFloat(topupAmount || 0);
          const updatedTotal = Number.parseFloat(updatedTotalPayments);
          const customerBalance = selectedCustomer?.[0]?.currentBalance || 0;

          // ❌ Cannot refund more than wallet balance
          if (refundAmount > customerBalance) {
            message.error("Refund amount cannot exceed wallet balance");
            setIsProcessingTopup(false);
            return;
          }

          // ❌ Prevent over refund payment
          if (updatedTotal > refundAmount) {
            message.error("Payment exceeds refund amount");
            setIsProcessingTopup(false);
            return;
          }

          // ✅ Only complete when FULLY PAID
          if (updatedTotal === refundAmount) {
            await handleWalletRefundComplete(refundAmount);
          } else {
            message.success(`${selectedPaymentMethod.name} payment of ${paymentAmount} added. Remaining: ${(refundAmount - updatedTotal).toFixed(2)}`);
            setIsProcessingTopup(false);
          }

          return;
        } else {
          await handleWalletTopUp(topupAmount);
        }
      } else {
        message.success(
          `${selectedPaymentMethod.name} payment of ${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}${paymentAmount}${
            currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
          } added. Remaining: ${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}${(topupTotal - updatedTotalPayments).toFixed(2)}${
            currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
          }`
        );
        setIsProcessingTopup(false);
      }
    } catch (error) {
      console.error(`${selectedPaymentMethod.name} top-up error:`, error);
      message.error(`${selectedPaymentMethod?.name || "Payment"} ${messages.errors.payments.wallet_topup_failed}`);
      setIsProcessingTopup(false);
    }
  };

  const handleCancelTopup = () => {
    setShowTopupModal(false);
    setTopupAmount("");
    setCurrentCashInput("");
    setCurrentCardInput("");
    setCurrentUPIInput("");
    setRedeemAmount("");
    setDynamicPaymentInput("");
    setCashTendered(0);
    //setSelectedPaymentMethod("Cash")
    setShowCardAmountInput(false);
    cardPaymentForm.resetFields();
    localStorage.removeItem("walletPayments");
    localStorage.removeItem("giftCardIntegrationTopupData");
    setDenaminationsKeyboard(true);
  };

  const handleShift = () => {
    setLayoutName(layoutName === "shift" ? "default" : "shift");
  };

  const handleKeyboardInputs = (button) => {
    const currentValue = cardPaymentForm.getFieldValue(inputFocused) || "";
    if (button === "{space}") {
      cardPaymentForm.setFieldsValue({
        [inputFocused]: `${currentValue} `,
      });
    } else if (button === "{backspace}") {
      cardPaymentForm.setFieldsValue({
        [inputFocused]: currentValue.slice(0, -1),
      });
    } else {
      cardPaymentForm.setFieldsValue({
        [inputFocused]: currentValue + button,
      });
    }
  };

  const handleQtyChange = (value, recordIndex, productId, isDecimal) => {
    let sanitizedValue = value.replace(/[^0-9.]/g, "");
    if (!isDecimal) {
      sanitizedValue = sanitizedValue.replaceAll(".", "");
    }

    // Handle multiple dots if decimal is allowed
    if (isDecimal) {
      const parts = sanitizedValue.split(".");
      if (parts.length > 2) {
        // Keep only the first dot and merge the rest
        sanitizedValue = parts[0] + "." + parts.slice(1).join("");
      }

      // Restrict precision to 3 digits after the decimal
      if (parts.length === 2 && parts[1].length > 3) {
        sanitizedValue = parts[0] + "." + parts[1].substring(0, 3);
      }
    }

    // Handle leading zeros for non-decimal values
    let displayValue = sanitizedValue;
    if (sanitizedValue.startsWith("0") && sanitizedValue.length > 1 && !sanitizedValue.includes(".")) {
      displayValue = sanitizedValue.substring(1);
    }

    // Allow raw decimal input without immediate formatting
    displayValue = displayValue === "" ? "0" : displayValue;

    const updatedTempCart = { ...tempCart };
    let tempData = { ...itemWeights };
    tempData[productId] = displayValue;
    setItemWeights(tempData);

    const parsedWeight = parseFloat(displayValue);
    if (!isNaN(parsedWeight)) {
      updatedTempCart[productId] = parsedWeight;
      setTempCart(updatedTempCart);
    }
  };

  const handleKeyDown = (e, isDecimal, index) => {
    let totalItems = (parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
      (item) => item.weight !== 0
    );
    if (!isDecimal && e.key === ".") {
      e.preventDefault();
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (index < totalItems.length - 1) {
        // Move to the next input
        inputRefs.current[index + 1]?.focus();
      } else {
        // If it's the last input, perform confirm action
        handleSubmit();
        setIsStockModal(false);
      }
    }
  };

  const handleKeyboardInput = (key) => {
    // Handle layout changes
    if (key === "{shift}") {
      setLayoutName(layoutName === "shift" ? "default" : "shift");
      return;
    }
    if (key === "{number}") {
      setLayoutName("number");
      return;
    }
    if (key === "{numbers}") {
      setLayoutName("numbers");
      return;
    }
    if (key === "{small}") {
      setLayoutName("shift");
      return;
    }
    if (key === "{caps}") {
      setLayoutName("default");
      return;
    }

    if (focusedInput !== null && currentRecord) {
      let currentValue = itemWeights[focusedInput] || "";
      currentValue = currentValue.toString();

      if (key === "{bksp}") {
        currentValue = currentValue.slice(0, -1);
        if (currentValue === "") {
          currentValue = "0";
        }
      } else if (key === "{enter}") {
        setOpen(false);
      } else if (key === ".") {
        if (currentRecord.isDecimal && !currentValue.includes(".")) {
          currentValue += ".";
        } else if (!currentRecord.isDecimal) {
          currentValue = currentValue.replace(".", "");
        }
      } else if (!/^\d*\.?\d*$/.test(currentValue + key)) {
        return; // Prevent invalid characters
      } else {
        if (currentValue === "0") {
          currentValue = key;
        } else {
          currentValue += key;
        }

        // Precision restriction for decimals
        if (currentRecord.isDecimal) {
          const parts = currentValue.split(".");
          if (parts.length === 2 && parts[1].length > 3) {
            currentValue = parts[0] + "." + parts[1].substring(0, 3);
          }
        }
      }

      // Update item weights and cart
      const updatedItemWeights = { ...itemWeights };
      updatedItemWeights[focusedInput] = currentValue;
      setItemWeights(updatedItemWeights);

      const updatedTempCart = { ...tempCart };
      updatedTempCart[focusedInput] = parseFloat(currentValue) || 0;
      setTempCart(updatedTempCart);
    }
  };

  const handleSubmit = async () => {
    let showPaymentsFlag = false;
    let deleteItems = [];
    await Promise.all(
      tempCart.items.map((item) => {
        if (itemWeights[item.lineId] > 0) {
          showPaymentsFlag = true;
          if (item.weight !== itemWeights[item.lineId]) {
            item.modified = true;
            return addProduct(item, itemWeights[item.lineId], true);
          }
        } else {
          deleteItems.push(item);
        }
      })
    );
    if (tempCart.items.length !== deleteItems.length) {
      await Promise.all(
        deleteItems.map((item) => {
          deleteProduct(item);
        })
      );
    } else {
      deleteCart();
    }
    if (showPaymentsFlag) {
      handleCartTotalClick();
    }
  };

  const handleDocumentClick = (type) => {
    if (type === "Invoice") {
      setShowDocumentPopup(false);
      setSelectedDocumentType("Invoice");
      cart.layAway = "N";
      setCart(cart);
      localStorage.setItem("cartObj", JSON.stringify(cart));
    } else if (type === "Advance") {
      if (selectedSaleTypeData?.cwrSaletype?.enableLayaway === "Y") {
        const requireCustomer = posConfig?.requireCustomerforLayaway === "Y" ? tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== cart.customer.cwrCustomerId : true;
        if (requireCustomer) {
          if (cart.items.length > 0 || posConfig?.enableItemRestrictionForAdvance !== "Y") {
            if (!cart.isReturn) {
              if (cart.paid === 0) {
                if (posConfig?.advanceLayaway === "Y") {
                  setShowDocumentPopup(false);
                  upsertPOSLog(cart, "LAY");
                  cart.layAway = "Y";
                  setCart(cart);
                  localStorage.setItem("cartObj", JSON.stringify(cart));
                  const payments =
                    showPayments.length >= 5
                      ? _.sortBy(showPayments, "sequenceNo").slice(
                          0,
                          tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === cart.customer.cwrCustomerId && showPayments.length === 6 ? 4 : 4
                        )
                      : showPayments;
                  setSelectedDocumentType("Advance");
                  setStartIndex(payments.length);
                  setShowPayments(payments);
                  setShowPaymentMethods(true);
                } else {
                  setShowDocumentPopup(false);
                  upsertPOSLog(cart, "LAY");
                  processOrder("layaway");
                }
              }
            } else {
              message.error(`${messages.warnings.cart.advance_not_supported}`);
            }
          } else {
            message.error(`${messages.warnings.cart.before_advance_check}`);
          }
        } else {
          message.warning(`${messages.errors.customer.select_for_proceed}`);
        }
      } else {
        message.error(`${messages.info.advance_not_enabled}`);
      }
    } else if (type === "Quotation") {
      if (posConfig?.enableQuotation === "Y") {
        setShowDocumentPopup(false);
        setSelectedDocumentType("Quotation");
        cart.isQuotation = true;
        setCart(cart);
        localStorage.setItem("cartObj", JSON.stringify(cart));
      }
    }
  };

  const renderReturnOptions = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {posConfig?.allowReturnRefund === "Y" && (
          <div
            onClick={() => setSelectedReturnType("REFUND")}
            style={{
              background: "#fff",
              border: selectedReturnType === "REFUND" ? "1px solid #3B82F6" : "1px solid #E5E7EB",
              borderRadius: "8px",
              padding: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
              <div
                style={{
                  background: "#F3F4F6",
                  padding: 3,
                  borderRadius: 8,
                }}
              >
                <CreditCardOutlined style={{ fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 500 }}>Return for Refund</div>
              </div>
            </div>

            {selectedReturnType === "REFUND" && <CheckCircleFilled style={{ color: "#3B82F6", fontSize: 18 }} />}
          </div>
        )}

        {posConfig?.allowReturnCreditNote === "Y" && (
          <div
            onClick={() => setSelectedReturnType("STORE_CREDIT")}
            style={{
              background: "#fff",
              border: selectedReturnType === "STORE_CREDIT" ? "1px solid #3B82F6" : "1px solid #E5E7EB",
              borderRadius: "8px",
              padding: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
              <div
                style={{
                  background: "#F3F4F6",
                  padding: 3,
                  borderRadius: 8,
                }}
              >
                <GiftOutlined style={{ fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 500 }}>Return for Store Credit</div>
              </div>
            </div>

            {selectedReturnType === "STORE_CREDIT" && <CheckCircleFilled style={{ color: "#3B82F6", fontSize: 18 }} />}
          </div>
        )}

        {posConfig?.allowReturnExchange === "Y" && (
          <div
            onClick={() => setSelectedReturnType("EXCHANGE")}
            style={{
              background: "#fff",
              border: selectedReturnType === "EXCHANGE" ? "1px solid #3B82F6" : "1px solid #E5E7EB",
              borderRadius: "8px",
              padding: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
              <div
                style={{
                  background: "#F3F4F6",
                  padding: 3,
                  borderRadius: 8,
                }}
              >
                <SwapOutlined style={{ fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 500 }}>Return & Exchange</div>
              </div>
            </div>

            {selectedReturnType === "EXCHANGE" && <CheckCircleFilled style={{ color: "#3B82F6", fontSize: 18 }} />}
          </div>
        )}
      </div>
    );
  };

  const handleGenericAmount = (value) => {
    setDynamicPaymentInput((prev) => {
      if (value === "x") return prev.slice(0, -1);
      if (value === "clear") return "";
      if (value === "." && prev.includes(".")) return prev;
      if (value === "00" && prev !== "") return prev + "00";
      return prev + value;
    });
  };

  const handleDynamicPaymentInput = (value) => {
    setDynamicPaymentInput((prev) => {
      if (value === "x") return prev.slice(0, -1);
      if (value === "clear") return "";
      if (value === "." && prev.includes(".")) return prev;
      return prev + value;
    });
  };

  const renderGenericWalletKeypad = () => {
    return (
      <Row style={{ padding: "0 1% 0 1%" }} gutter={[8, 6]}>
        <Col span={6}>
          <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("1")}>
            1
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("2")}>
            2
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("3")}>
            3
          </button>
        </Col>
        <Col span={6}>
          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} id="sm-amount-buttonRemove" onClick={() => handleGenericAmount("x")}>
            <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("4")}>
            4
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("5")}>
            5
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("6")}>
            6
          </button>
        </Col>
        <Col span={6}>
          <button
            id="sm-amount-buttonClear"
            className="amt-dial-btn-market"
            style={{ background: themeJSON?.keyBoardColor }}
            onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}
          >
            1,2,3...
          </button>
        </Col>
        <Col span={18}>
          <Row gutter={[8, 6]}>
            <Col span={8}>
              <button id="sm-amount-button7" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("7")}>
                7
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button8" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("8")}>
                8
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("9")}>
                9
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("0")}>
                0
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button00" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount("00")}>
                00
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button." className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleGenericAmount(".")}>
                .
              </button>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <button
            id="sm-amount-buttonEnter"
            className="amt-dial-btn-market2"
            style={{ background: themeJSON?.keyBoardColor }}
            onClick={async () => {
              if (!topupAmount || parseFloat(topupAmount) <= 0) {
                message.warning("Please enter valid amount");
                return;
              }

              if (!dynamicPaymentInput || parseFloat(dynamicPaymentInput) <= 0) {
                message.warning("Please enter valid payment amount");
                return;
              }

              await enterTotalQtyForWallet(); // 🔥 use same engine as Cash/Card/UPI
              setDynamicPaymentInput(""); // clear after adding
            }}
          >
            Enter
          </button>
        </Col>
      </Row>
    );
  };

  const walletPreferences = (() => {
    try {
      const raw = tillData?.tillAccess?.walletPreferences;
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) ? parsed[0] : parsed;
    } catch {
      return null;
    }
  })();

  const walletPaymentSettings = walletPreferences?.paymentsettings || null;

  const paymentMethodForTopup = _.sortBy(
    (() => {
      const allMethods = tillData?.tillAccess?.csBunit?.paymentMethodList || [];

      if (!walletPaymentSettings) {
        // No paymentsettings — fall back to existing behavior
        return showRefundModal ? allMethods.filter((pm) => pm.isReturns === "Y" && pm.isWallet !== "Y") : allMethods;
      }

      if (showRefundModal) {
        // Show only methods where refund === "Y" in paymentsettings
        const refundAllowedIds = walletPaymentSettings.filter((s) => s.refund === "Y").map((s) => s.fin_paymentmethod_id);
        return allMethods.filter((pm) => refundAllowedIds.includes(pm.finPaymentmethodId));
      } else {
        // Show only methods where topup === "Y" in paymentsettings
        const topupAllowedIds = walletPaymentSettings.filter((s) => s.topup === "Y").map((s) => s.fin_paymentmethod_id);
        return allMethods.filter((pm) => topupAllowedIds.includes(pm.finPaymentmethodId));
      }
    })(),
    ["sequenceNo", "name"]
  );

  const pageSize = 5;
  const totalPages = Math.ceil(paymentMethodForTopup?.length / pageSize);

  const visibleMethods =
    paymentMethodForTopup?.length <= pageSize ? paymentMethodForTopup : paymentMethodForTopup?.slice(paymentPage * pageSize, paymentPage * pageSize + pageSize);

  return (
    <Fragment>
      {/* sales rep modal start */}
      <Drawer
        closable={true}
        placement="bottom"
        title={
          <div style={{ display: "flex", alignItems: "center", height: "2vh", fontSize: "1vw" }}>
            <p style={{ fontSize: "1.5em", marginTop: "3vh", fontWeight: "500", color: "#0F0718", flex: 1, textAlign: "center" }}>Select a Sales Representative</p>
            <img
              src={Close}
              onClick={() => {
                if (posConfig?.requireSalesRepresentative === "Y") {
                  const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj"));
                  if (exchangeCartObj) {
                    if (exchangeCartObj?.salesRepId === null) {
                      setOpenSalesRep({ flag: true, level: "order" });
                    }
                  } else {
                    if (cart?.salesRepId === null) {
                      setOpenSalesRep({ flag: true, level: "order" });
                    }
                  }
                  message.warning("Please select a Sales Representative to continue with this bill.");
                } else {
                  setSelectedSalesRep({});
                  setOpenSalesRep({ flag: false, level: "" });
                  setOpen(false);
                  setLayoutName("default");
                  setSalesRepValue("");
                  if (searchInputRef?.current) {
                    searchInputRef?.current.focus();
                  }
                }
              }}
              style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
            />
          </div>
        }
        closeIcon={null}
        visible={openSalesRep?.flag}
        className="filter"
        bodyStyle={{ paddingBottom: 0, paddingTop: 0 }}
        onClose={() => {
          if (posConfig?.requireSalesRepresentative === "Y") {
            const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj"));
            if (exchangeCartObj) {
              if (exchangeCartObj?.salesRepId === null) {
                setOpenSalesRep({ flag: true, level: "order" });
              }
            } else {
              if (cart?.salesRepId === null) {
                setOpenSalesRep({ flag: true, level: "order" });
              }
            }
          } else {
            setSelectedSalesRep({});
            setOpenSalesRep({ flag: false, level: "" });
            setOpen(false);
          }
        }}
        height="90vh"
      >
        <Row style={{ paddingLeft: "0.7vw", fontSize: "1vw", paddingBottom: "2vh" }}>
          <Col span={9}>
            <Input
              type="text"
              ref={salesRepRef}
              value={salesRepValue}
              className="productSearch"
              placeholder={`Search`}
              // id="giftCardSearchInput"
              id="sm-product-search"
              onChange={handleSearchChange}
              onFocus={() => {
                setKeyboardType({
                  searchCus: false,
                  parkedBill: false,
                  salesHistory: false,
                  salesHistoryCus: false,
                  product: false,
                  giftCardSearch: false,
                  salesRep: true,
                  addCustomer: false,
                });
                setTimeout(() => {
                  keyboardRef?.current?.setInput(salesRepValue);
                  setOpen(true);
                }, 300);
              }}
              onPressEnter={(e) => e.preventDefault()}
              style={{
                width: "35vw",
                padding: "5px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "1vw",
                color: "#0F0718",
                borderColor: "rgba(0, 0, 0, 0.25)",
              }}
              prefix={
                <img
                  src={SearchIcon}
                  alt=""
                  style={{
                    width: "15px",
                    height: "15px",
                    paddingLeft: "0.2vw",
                  }}
                />
              }
            />
          </Col>
        </Row>
        <Scrollbars style={{ height: "55vh", width: "100%" }} renderThumbHorizontal={renderThumbHorizontalScroll}>
          <Row gutter={[16, 16]}>
            {salesRepData?.map((res) => (
              <Col
                span={6}
                style={{
                  background: selectedSalesRep.code === res.code ? "#cae5bd" : "#fff",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  margin: "0 1rem",
                  padding: "0rem 0.5rem",
                }}
                // onClick={() => {
                //   setSelectedSalesRep(res);
                // }}
                onClick={async () => {
                  // let cartObj = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
                  const selectedReturnType = localStorage.getItem("selectedReturnType");
                  let cartObj = selectedReturnType === "EXCHANGE" ? JSON.parse(localStorage.getItem("exchangeCartObj")) : JSON.parse(localStorage.getItem("cartObj"));
                  if (openSalesRep.level === "order") {
                    cartObj.salesRepId = res.s_salesrep_id;
                    cartObj.salesRepName = res.name;
                    if (isExchange) {
                      localStorage.setItem("exchangeCartObj", JSON.stringify(cartObj));
                      const cartObjData = JSON.parse(localStorage.getItem("cartObj"));
                      if (!cartObjData?.salesRepName && cartObjData?.salesRepId) {
                        const salesRep = await db.salesRep.get(cartObjData.salesRepId);
                        if (salesRep) {
                          const cartData = {
                            ...cartObjData,
                            salesRepName: salesRep.name,
                          };

                          localStorage.setItem("cartObj", JSON.stringify(cartData));
                          setCart(cartData);
                        }
                      }
                      if (!cartObjData?.salesRepId) {
                        const cartData = {
                          ...cartObjData,
                          salesRepId: res.s_salesrep_id,
                          salesRepName: res.name,
                        };

                        localStorage.setItem("cartObj", JSON.stringify(cartData));
                        setCart(cartData);
                      }
                    } else {
                      setCart(cartObj);
                      localStorage.setItem("cartObj", JSON.stringify(cartObj));
                    }

                    setSelectedSalesRep({});
                    setOpenSalesRep({ flag: false, level: "" });
                  } else if (openSalesRep.level === "line") {
                    cartObj?.items?.map((lineItem) => {
                      if (lineItem.productId === selectedProductInCart.productId && lineItem.lineId === selectedProductInCart.lineId) {
                        lineItem.salesRepId = res.s_salesrep_id;
                        lineItem.salesRepName = res.name;
                      }
                    });
                    if (isExchange) {
                      localStorage.setItem("exchangeCartObj", JSON.stringify(cartObj));
                    } else {
                      setCart(cartObj);
                      localStorage.setItem("cartObj", JSON.stringify(cartObj));
                    }
                    setSelectedSalesRep({});
                    setOpenSalesRep({ flag: false, level: "" });
                  }
                }}
              >
                <img src={User} alt="" style={{ marginRight: "10px", height: "2.5rem", margin: "0.7rem 0 " }} />
                <span style={{ marginLeft: "10px", margin: "0.7rem 0px 0.7rem 10px", fontSize: "1vw" }}>
                  <p style={{ margin: 0, fontWeight: 500, fontSize: "1em", color: "#0F0718" }}>{res.name}</p>
                  <span style={{ fontSize: "0.8em", fontWeight: 500, color: "#0F0718" }}>{res.code}</span>
                </span>
              </Col>
            ))}
          </Row>
        </Scrollbars>
        <Row>
          <Col span={24} style={{ textAlign: "right", paddingTop: "1rem" }}>
            <Button
              style={{ backgroundColor: "#0F0718", color: "#fff", height: "7vh", width: "15vw", borderRadius: "7px" }}
              disabled={!selectedSalesRep?.code}
              onClick={() => {
                let cartObj = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
                if (openSalesRep.level === "order") {
                  cartObj.salesRepId = selectedSalesRep.s_salesrep_id;
                  cartObj.salesRepName = selectedSalesRep.name;

                  if (isExchange) {
                    localStorage.setItem("exchangeCartObj", JSON.stringify(cartObj));
                  } else {
                    setCart(cartObj);
                    localStorage.setItem("cartObj", JSON.stringify(cartObj));
                  }
                  setSelectedSalesRep({});
                  setOpenSalesRep({ flag: false, level: "" });
                } else if (openSalesRep.level === "line") {
                  cartObj?.items?.map((lineItem) => {
                    if (lineItem.productId === selectedProductInCart.productId && lineItem.lineId === selectedProductInCart.lineId) {
                      lineItem.salesRepId = selectedSalesRep.s_salesrep_id;
                      lineItem.salesRepName = selectedSalesRep.name;
                    }
                  });
                  if (isExchange) {
                    localStorage.setItem("exchangeCartObj", JSON.stringify(cartObj));
                  } else {
                    setCart(cartObj);
                    localStorage.setItem("cartObj", JSON.stringify(cartObj));
                  }
                  setSelectedSalesRep({});
                  setOpenSalesRep({ flag: false, level: "" });
                }
              }}
            >
              Continue
            </Button>
          </Col>
        </Row>
      </Drawer>
      {/* sales rep modal end */}

      {/* Stock Confirmation Start */}
      <Drawer
        closable={true}
        placement="bottom"
        title={
          <div style={{ display: "flex", alignItems: "center", height: "2vh", fontSize: "1vw" }}>
            <p style={{ fontSize: "1.5em", marginTop: "3vh", fontWeight: "500", color: "#0F0718", flex: 1, textAlign: "center" }}>Stock Confirmation</p>
            <img
              src={Close}
              onClick={() => {
                setIsStockModal(false);
                setOpen(false);
                setLayoutName("default");
              }}
              style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
            />
          </div>
        }
        closeIcon={null}
        visible={isStockModal}
        className="filter"
        bodyStyle={{ padding: "0 4vw" }}
        onClose={() => {
          setIsStockModal(false);
          setOpen(false);
          setLayoutName("default");
        }}
        height="90vh"
      >
        <Table
          className="sm-cart-table-pos-stock"
          style={{
            width: "100%",
            overflowY: "auto",
            border: "none",
            borderRadius: "7px",
            padding: "0px 7px",
            height: "67vh",
            background: themeJSON.productTableBGColor || "#fff",
          }}
          pagination={false}
          dataSource={(parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
            (item) => item.availableQty < item.weight
          )}
          sticky
          id="sm-cart-table"
          columns={[
            {
              title: "Item Name",
              dataIndex: "name",
              key: "name",
              width: "32%",
              render: (text, record, index) => {
                return (
                  <>
                    <div onClick={() => {}} id="sm-product-name" className="tableRow">
                      {record.name}
                    </div>
                    <div className="offerName">
                      {record.availableQty >= record.weight ? (
                        <p style={{ margin: 0, color: "#009000" }}>Available</p>
                      ) : record.availableQty > 0 && record.weight > 0 ? (
                        <p style={{ margin: 0, color: "#FF5E0E" }}>Only {record.availableQty} Available</p>
                      ) : (
                        <p style={{ margin: 0, color: "red" }}>Out Of Stock</p>
                      )}
                    </div>
                  </>
                );
              },
            },
            {
              title: "UOM",
              dataIndex: "uom_name",
              key: "uom_name",
              width: "12%",
              render: (text, record, index) => {
                return <div style={{ textAlign: "left" }}>{text}</div>;
              },
              align: "center",
            },
            {
              title: "Order Qty",
              dataIndex: "weight",
              key: "weight",
              width: "15%",
              align: "right",
              render: (text, record) => {
                return <div style={{ textAlign: "right" }}>{parseFloat(text).toFixed(2)}</div>;
              },
            },
            {
              title: "Available Qty",
              dataIndex: "availableQty",
              key: "availableQty",
              width: "15%",
              align: "right",
              render: (text, record) => {
                return (
                  <div style={{ textAlign: "right", color: text > 0 ? "#0F0718" : "red" }}>
                    {text?.toFixed(2).length < 8 ? parseFloat(text)?.toFixed(2) : `${text?.toString().substring(0, 8)}`}
                  </div>
                );
              },
            },
            {
              title: "Update Order Qty",
              dataIndex: "availableQty",
              key: "availableQty",
              width: "22%",
              align: "center",
              paddingLeft: "3vw",
              textAlign: "right",
              render: (text, record, index) => {
                return (
                  <Input
                    key={record.lineId}
                    style={{ width: "10vw", textAlign: "right" }}
                    ref={(el) => (inputRefs.current[index] = el)}
                    value={itemWeights[record.lineId]}
                    onChange={(e) => handleQtyChange(e.target.value, index, record.lineId, record.isDecimal)}
                    onPressEnter={(e) => e.preventDefault()}
                    onKeyDown={(e) => handleKeyDown(e, record.isDecimal, index)}
                    onFocus={() => {
                      setFocusedInput(record.lineId);
                      setOpen(true);
                      setCurrentRecord(record);
                    }}
                  />
                );
              },
            },
          ]}
        />
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            style={{
              backgroundColor: "#fff",
              color: "#2F3856",
              height: "7vh",
              width: "15vw",
              borderRadius: "7px",
              marginTop: "1rem",
            }}
            onClick={() => {
              setIsStockModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "#2F3856",
              color: "#fff",
              height: "7vh",
              width: "15vw",
              borderRadius: "7px",
              marginTop: "1rem",
              marginLeft: "1rem",
            }}
            onClick={() => {
              handleSubmit();
              setIsStockModal(false);
            }}
          >
            Confirm
          </Button>
        </div>
      </Drawer>
      {/* Stock Confirmation End */}

      {open && showVirtualKeyboard && (
        <Drawer placement="bottom" closable={false} bodyStyle={{ paddingBottom: 0 }} height="47vh" visible={open && showVirtualKeyboard} mask={false}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
            <img
              src={Close}
              onClick={() => {
                setOpen(false);
              }}
              style={{
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
          <div style={{ padding: "0 4vw 0" }}>
            <Keyboard
              keyboardRef={(r) => {
                keyboardRef.current = r;
                // if (keyboardType.salesRep) {
                //   salesRepRef.current = r;
                // }
              }}
              onChange={(val) => {
                if (keyboardType.salesRep) {
                  setSalesRepValue(val);
                  handleSearchChange({ target: { value: val } });
                  if (salesRepRef && salesRepRef.current) {
                    setTimeout(() => {
                      salesRepRef.current.focus();
                    }, 10);
                  }
                }
              }}
              layoutName={layoutName}
              display={{
                "{bksp}": "⌫",
                "{numbers}": "123",
                "{shift}": "⇧",
                "{enter}": "Enter",
                "{space}": "Space",
                "{number}": "123",
                "{caps}": "ABC",
                "{small}": "abc",
              }}
              layout={{
                shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} @ {space} . {enter}"],
                numbers: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{caps} {space} {enter}"],
                number: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{small} {space} {enter}"],
                default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} @ {space} . {enter}"],
              }}
              onKeyPress={handleKeyboardInput}
            />
          </div>
        </Drawer>
      )}

      {/* Document Type select Popup start*/}
      <Modal
        visible={showDocumentPopup}
        closable={true}
        onCancel={() => {
          setShowDocumentPopup(false);
        }}
        keyboard={false}
        footer={null}
        width="33%"
        centered
        bodyStyle={{ padding: 10, backgroundColor: "#F3F4F9" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "4vh 2.5vw" }}>
          {documentTypes
            ?.filter((doc) => doc.type !== selectedDocumentType)
            ?.map((doc) => {
              return (
                doc.isVisible && (
                  <Button
                    key={doc.type}
                    style={{
                      height: "9vh",
                      borderRadius: "5px",
                      cursor: doc.isEnabled ? "pointer" : "not-allowed",
                      backgroundColor: "#2F3856",
                      color: "#fff",
                      fontSize: "1.1rem",
                      border: "1px solid #2F3856",
                      textAlign: "center",
                      fontWeight: 400,
                    }}
                    onClick={() => doc.isEnabled && handleDocumentClick(doc.type)}
                  >
                    {doc.type}
                  </Button>
                )
              );
            })}
        </div>
      </Modal>
      {/* Document Type select Popup end*/}

      {/* Customer Wallet Modal Start */}
      <Drawer
        className="customerWalletDrawer"
        visible={showCustomerWallet}
        closable={false}
        maskClosable={false}
        onClose={() => {
          setShowCustomerWallet(false);
          setSelectedCustomer(null);
          setCustomerSearchValue("");
          setShowTopupModal(false);
          setShowTransactionsModal(false);
          setShowRefundModal(false);
          setTopupAmount("");
          setDynamicPaymentInput("");
          setRedeemAmount("");
          //setSelectedPaymentMethod("Cash")
        }}
        placement="right"
        width="62%"
        headerStyle={{ background: "white", borderBottom: "none" }}
        bodyStyle={{ padding: "0.5rem", paddingTop: 0, background: "white" }}
        style={{ borderRadius: "15px" }}
        title={
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ fontSize: "1.2rem", fontWeight: "550", color: "#0F0718", paddingTop: "13px" }}>
              <img src={wallet || "/placeholder.svg"} style={{ height: "3.5vh", paddingRight: "5px", paddingLeft: "7px" }} alt="" />
              {showRefundModal
                ? "Refund Wallet"
                : showTopupModal
                  ? "Top-up Wallet"
                  : showTransactionsModal
                    ? `Transaction History - ${selectedCustomer[0]?.name || "Customer"}`
                    : "Customer Wallet Management"}
            </div>
            <img
              src={Close || "/placeholder.svg"}
              onClick={() => {
                if (showTopupModal || showTransactionsModal || showRefundModal) {
                  setShowTopupModal(false);
                  setShowTransactionsModal(false);
                  setShowRefundModal(false);
                  setTopupAmount("");
                  setCurrentCashInput("");
                  setCurrentCardInput("");
                  setCurrentUPIInput("");
                  setDynamicPaymentInput("");
                  setRedeemAmount("");
                  setCashTendered(0);
                  setShowCardAmountInput(false);
                  cardPaymentForm.resetFields();
                  localStorage.removeItem("walletPayments");
                  localStorage.removeItem("walletDataForCardIntegration");
                  setSelectedPaymentMethod({});
                } else {
                  setShowCustomerWallet(false);
                  setSelectedCustomer(null);
                  setCustomerSearchValue("");
                  setShowTopupModal(false);
                  setShowTransactionsModal(false);
                  setTopupAmount("");
                  setCurrentCashInput("");
                  setCurrentCardInput("");
                  setCurrentUPIInput("");
                  setRedeemAmount("");
                  setDynamicPaymentInput("");
                  setCashTendered(0);
                  setShowCardAmountInput(false);
                  cardPaymentForm.resetFields();
                  localStorage.removeItem("walletPayments");
                  localStorage.removeItem("walletDataForCardIntegration");
                  setSelectedPaymentMethod({});
                }
              }}
              style={{ cursor: "pointer", width: "1.5vw" }}
              alt="Close"
            />
          </div>
        }
      >
        {showTopupModal || showRefundModal ? (
          // Top-up Modal Section
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            <div
              style={{
                height: "3em",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                verticalAlign: "center",
                fontSize: "1rem",
                backgroundColor: "#f0f0f0",
                color: "#28a745",
                fontWeight: "bold",
                marginTop: "0.5rem",
                //marginBottom: "1rem",
                borderRadius: "12px",
              }}
            >
              Current Balance: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
              {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
              {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            </div>
            <Card
              style={{
                borderRadius: "8px",
                border: "none",
                background: "transparent",
              }}
            >
              <Form layout="vertical" onFinish={handleCardPayment} form={cardPaymentForm}>
                <Row gutter={[10, 10]}>
                  <Col span={24}>
                    <div>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "0.3rem",
                          marginTop: "0.3rem",
                          color: "#0F0718",
                          fontWeight: "550",
                          fontSize: "0.9rem",
                        }}
                      >
                        {showRefundModal ? "Refund Amount" : "Top-up Amount"}
                      </label>
                      <Input
                        ref={topupInputRef}
                        size="large"
                        value={topupAmount}
                        onChange={(e) => handleTopupAmountChange(e.target.value)}
                        onBlur={formatOnBlur}
                        onFocus={() => setFocusedInputField("topupAmount")}
                        placeholder="0"
                        style={{
                          textAlign: "right",
                          fontSize: "1rem",
                          borderRadius: "6px",
                        }}
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <Scrollbars style={{ height: "6vh" }}>
                      {matchedPayments?.length > 0 ? (
                        matchedPayments.map((item, index) => (
                          <Row key={index} style={{ fontSize: "1vw" }}>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "0.8vw",
                                fontWeight: "450",
                                textAlign: "left",
                              }}
                            >
                              <p style={{ margin: "0" }}>{item.name}</p>
                            </Col>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingRight: "1vw",
                                textAlign: "right",
                                justifyContent: "end",
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "right",
                                  margin: "0",
                                  fontWeight: "500",
                                  paddingRight: "1.2vw",
                                }}
                              >
                                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)}
                                {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                              </p>
                            </Col>
                          </Row>
                        ))
                      ) : (
                        <Row style={{ fontSize: "1vw", textAlign: "center" }}>
                          <Col span={24}>
                            <p style={{ margin: "0", color: "#888" }}>No payments added</p>
                          </Col>
                        </Row>
                      )}
                    </Scrollbars>
                  </Col>
                  <Col span={24}>
                    <div>
                      <label
                        style={{
                          display: "block",
                          color: "#0F0718",
                          fontWeight: "550",
                          fontSize: "0.9rem",
                        }}
                      >
                        Payment Method
                      </label>
                      <div style={{ display: "flex", gap: 5 }}>
                        {visibleMethods?.map((pm) => (
                          <Button
                            key={pm.name}
                            type={selectedPaymentMethod?.name === pm.name ? "primary" : "default"}
                            onClick={() => {
                              setCurrentCashInput("");
                              setCurrentCardInput("");
                              setCurrentUPIInput("");
                              setCashTendered(0);
                              cardPaymentForm.resetFields();
                              setDenaminationsKeyboard(pm.name.toLowerCase() === "cash");
                              setFocusedInputField(null);
                              setSelectedPaymentMethod(pm);
                              autoFillEnterAmount(topupAmount);
                              setShowCardAmountInput(true);
                              if (pm.isBankTransfer === "Y") {
                                setBankTransferContext(showRefundModal ? "walletrefund" : "wallettopup");
                                setWalletBankTransferPaymentMethod(pm); // ✅ own state, not giftCardTopupPaymentMethod
                                setRedeemAmount(topupAmount || "");
                                setIsBankTransferOpen(true);
                                financialForm.resetFields();
                                setFinancialDocument(null);
                                return;
                              }
                              setTimeout(() => {
                                if (pm.name.toLowerCase() === "cash") {
                                  cashInputRef.current?.focus();
                                  setFocusedInputField("currentCashInput");
                                } else if (pm.name.toLowerCase() === "card" && (posConfig?.transactionID !== "Y" || showCardAmountInput)) {
                                  cardInputRef.current?.focus();
                                  setFocusedInputField("currentCardInput");
                                } else if (pm.name.toLowerCase() === "upi") {
                                  upiInputRef.current?.focus();
                                  setFocusedInputField("currentUPIInput");
                                }
                              }, 0);
                            }}
                            style={{
                              flex: 1,
                              height: "40px",
                              fontSize: "0.9rem",
                              backgroundColor: selectedPaymentMethod?.name === pm.name ? "#2F3856" : themeJSON.paymentMethodsBGColor || "#fff",
                              color: selectedPaymentMethod?.name === pm.name ? "#fff" : "#0F0718",
                              borderColor: themeJSON.paymentMethodsBGColor || "#e8e8e8",
                              borderRadius: "7px",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <span>
                                {pm.name.toLowerCase() === "cash" ? (
                                  <>
                                    {currenciesList[0]?.currSymbol || ""} {pm.name}
                                  </>
                                ) : pm.name.toLowerCase() === "card" ? (
                                  <>
                                    <img src={cardType} style={{ height: "15px", marginRight: "5px" }} alt="card" />
                                    {pm.name}
                                  </>
                                ) : pm.name.toLowerCase() === "upi" ? (
                                  <>
                                    <img src={UPI} style={{ height: "15px", marginRight: "5px" }} alt="upi" />
                                    {pm.name}
                                  </>
                                ) : (
                                  <>{pm.name}</>
                                )}
                              </span>
                            </div>
                          </Button>
                        ))}
                        {paymentMethodForTopup?.length > pageSize && (
                          <Button
                            key="morePayments"
                            onClick={() => {
                              setPaymentPage((prev) => (prev + 1) % totalPages);
                            }}
                            style={{
                              flex: 1,
                              height: "40px",
                              fontSize: "0.9rem",
                              borderRadius: "7px",
                            }}
                          >
                            ...
                          </Button>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* Rest of the top-up modal content */}
                  {selectedPaymentMethod?.name === "Cash" && denaminationsKeyboard ? (
                    // Cash denomination keyboard
                    <Col span={24}>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "550",
                            fontSize: "0.9rem",
                          }}
                        >
                          Enter Amount
                        </label>
                        <div>
                          <Row>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "6vh",
                                margin: "0 0% 2.7% 0%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                                border: "1px solid #f0f0f0",
                              }}
                              value={currentCashInput}
                              id="sm-amount-input"
                              onChange={(e) => setCurrentCashInput(e.target.value?.replace(/[^\d.]/g, ""))}
                              onFocus={() => setFocusedInputField("currentCashInput")}
                              ref={cashInputRef}
                              placeholder="0"
                            />
                          </Row>
                          <Row style={{ padding: "0 0% 0 0.5%" }}>
                            <Col span={18}>
                              <Row gutter={[8, 5]} style={{ display: "flex", flexDirection: "row-reverse" }}>
                                {currenciesData.map((currency) => (
                                  <Col span={8} key={currency.value}>
                                    <button
                                      id={`sm-amount-button${currenciesData.indexOf(currency) + 1}`}
                                      className="amt-dial-btn-market"
                                      onClick={() => handleDenominationClick(currency.value)}
                                      disabled={currency.value === 999999}
                                      style={{
                                        color: currency.value !== 999999 ? "#0f0718" : "transparent",
                                        background: themeJSON?.keyBoardColor,
                                      }}
                                    >
                                      {currency.value}
                                    </button>
                                  </Col>
                                ))}
                              </Row>
                            </Col>
                            <Col span={6}>
                              <Row style={{ padding: "0 0 2% 4%" }}>
                                <button
                                  className="amt-dial-btn-market"
                                  id="sm-amount-buttonRemove"
                                  onClick={() => handleTotalQty("x")}
                                  style={{ background: themeJSON?.keyBoardColor }}
                                >
                                  <img src={CancelArrow} alt="back space" width={25} height={15} />
                                </button>
                              </Row>
                              <Row style={{ padding: "0 0 2% 4%" }}>
                                <button
                                  id="sm-amount-buttonClear"
                                  className="amt-dial-btn-market"
                                  onClick={() => {
                                    handleTotalQty("clear");
                                    setDenaminationsKeyboard(false);
                                    setLayoutName("numbers");
                                  }}
                                  style={{ background: themeJSON?.keyBoardColor }}
                                >
                                  1,2,3...
                                </button>
                              </Row>
                              <Row style={{ padding: "0 0 0 4%" }}>
                                <button
                                  id="sm-amount-buttonEnter"
                                  className="amt-dial-btn-market2"
                                  onClick={enterTotalQtyForWallet}
                                  style={{ background: themeJSON?.keyBoardColor }}
                                >
                                  Enter
                                </button>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  ) : selectedPaymentMethod?.name === "Cash" && !denaminationsKeyboard ? (
                    // Numeric keyboard for cash
                    <Col span={24}>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "550",
                            fontSize: "0.9rem",
                          }}
                        >
                          Enter Amount
                        </label>
                        <div>
                          <Row>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "6vh",
                                margin: "0 0% 2.7% 0%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                                border: "1px solid #f0f0f0",
                              }}
                              value={currentCashInput}
                              id="sm-amount-input"
                              onChange={(e) => setCurrentCashInput(e.target.value?.replace(/[^\d.]/g, ""))}
                              onFocus={() => setFocusedInputField("currentCashInput")}
                              ref={cashInputRef}
                              placeholder="0"
                            />
                          </Row>
                          <Row style={{ padding: "0 0% 0 0.5%" }} gutter={[8, 6]}>
                            <Col span={6}>
                              <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("1")}>
                                1
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("2")}>
                                2
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("3")}>
                                3
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                className="amt-dial-btn-market"
                                id="sm-amount-buttonRemove"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => handleTotalQty("x")}
                              >
                                <img src={CancelArrow} alt="back space" width={25} height={15} />
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("4")}>
                                4
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("5")}>
                                5
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("6")}>
                                6
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                id="sm-amount-buttonClear"
                                className="amt-dial-btn-market"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => {
                                  setDenaminationsKeyboard(true);
                                  setLayoutName("numbers");
                                }}
                              >
                                1,2,3...
                              </button>
                            </Col>
                            <Col span={18}>
                              <Row gutter={[8, 6]}>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button7"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("7")}
                                  >
                                    7
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button8"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("8")}
                                  >
                                    8
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button9"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("9")}
                                  >
                                    9
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button0"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("0")}
                                  >
                                    0
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button00"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty(".")}
                                  >
                                    .
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button-clear"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("clear")}
                                  >
                                    Clear
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" style={{ background: themeJSON?.keyBoardColor }} onClick={enterTotalQtyForWallet}>
                                Enter
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  ) : // ) : selectedPaymentMethod?.name === "Card" && posConfig?.transactionID === "Y" && !showCardAmountInput ? (
                  //   // Card payment details
                  //   <Row>
                  //     <Col span={10} style={{ paddingRight: "1vw" }}>
                  //       <Row>
                  //         <Col span={20}>
                  //           <Form.Item
                  //             style={{ marginBottom: "10px" }}
                  //             name="transactionId"
                  //             rules={[
                  //               {
                  //                 required: posConfig?.transactionID_mandatory === "Yes",
                  //                 message: `Please enter Transaction ID`,
                  //               },
                  //             ]}
                  //             label={
                  //               <span
                  //                 style={{
                  //                   color: "#000",
                  //                   fontSize: "1rem",
                  //                   fontWeight: "500",
                  //                 }}
                  //               >
                  //                 Transaction ID
                  //               </span>
                  //             }
                  //           >
                  //             <Input
                  //               id="transactionId"
                  //               placeholder={`Transaction ID`}
                  //               onFocus={() => {
                  //                 setInputFocused("transactionId");
                  //                 setLayoutName("default");
                  //               }}
                  //               size="large"
                  //               onPressEnter={(e) => e.preventDefault()}
                  //               allowClear={false}
                  //               style={{
                  //                 borderRadius: "6px",
                  //                 padding: "8px 12px",
                  //               }}
                  //             />
                  //           </Form.Item>
                  //         </Col>
                  //         <Col span={20}>
                  //           {posConfig?.authorizationCode === "Y" && (
                  //             <Form.Item
                  //               style={{ marginBottom: "10px" }}
                  //               name="authorization"
                  //               rules={[
                  //                 {
                  //                   required: posConfig?.authorizationCode_mandatory === "Yes",
                  //                   message: `Please enter Authorization Code`,
                  //                 },
                  //               ]}
                  //               label={
                  //                 <span
                  //                   style={{
                  //                     color: "#000",
                  //                     fontSize: "1rem",
                  //                     fontWeight: "500",
                  //                   }}
                  //                 >
                  //                   Authorization Code
                  //                 </span>
                  //               }
                  //             >
                  //               <Input
                  //                 id="pin"
                  //                 ref={authorizationRef}
                  //                 placeholder={`Authorization Code`}
                  //                 size="large"
                  //                 onPressEnter={(e) => e.preventDefault()}
                  //                 onFocus={() => {
                  //                   setInputFocused("authorization");
                  //                   setLayoutName("default");
                  //                 }}
                  //                 allowClear={false}
                  //                 style={{
                  //                   borderRadius: "6px",
                  //                   padding: "8px 12px",
                  //                 }}
                  //               />
                  //             </Form.Item>
                  //           )}
                  //         </Col>
                  //         <Col span={20}>
                  //           {posConfig?.cardType === "Y" && (
                  //             <Form.Item
                  //               style={{ marginBottom: "10px" }}
                  //               name="cardType"
                  //               rules={[
                  //                 {
                  //                   required: posConfig?.cardType_mandatory === "Yes",
                  //                   message: `Please select Card Type`,
                  //                 },
                  //               ]}
                  //               label={
                  //                 <span
                  //                   style={{
                  //                     color: "#000",
                  //                     fontSize: "1rem",
                  //                     fontWeight: "500",
                  //                   }}
                  //                 >
                  //                   Card Type
                  //                 </span>
                  //               }
                  //             >
                  //               <Select className="selecItem" placeholder={<span className="cartSelect">Card Type</span>} size="large" style={{ borderRadius: "6px" }}>
                  //                 <Option className="cartOption" key="VI" value="VI">
                  //                   Visa - VI
                  //                 </Option>
                  //                 <Option className="cartOption" key="MA" value="MA">
                  //                   Master Card - MA
                  //                 </Option>
                  //                 <Option className="cartOption" key="RU" value="RU">
                  //                   Rupay - RU
                  //                 </Option>
                  //                 <Option className="cartOption" key="AM" value="AM">
                  //                   Amex - AM
                  //                 </Option>
                  //                 <Option className="cartOption" key="ME" value="ME">
                  //                   Maestro - ME
                  //                 </Option>
                  //               </Select>
                  //             </Form.Item>
                  //           )}
                  //         </Col>
                  //         <Col span={20}>
                  //           {posConfig?.CardNumber === "Y" && (
                  //             <Form.Item
                  //               style={{ marginBottom: "10px" }}
                  //               name="cardNumber"
                  //               rules={[
                  //                 {
                  //                   required: posConfig?.CardNumber_mandatory === "Yes",
                  //                   message: `Please enter Card Number`,
                  //                 },
                  //                 {
                  //                   pattern: /^\d{4}$/,
                  //                   message: `Card Number must be exactly 4 digits`,
                  //                 },
                  //               ]}
                  //               label={
                  //                 <span
                  //                   style={{
                  //                     color: "#000",
                  //                     fontSize: "1rem",
                  //                     fontWeight: "500",
                  //                   }}
                  //                 >
                  //                   Card Number (Last 4 Digits)
                  //                 </span>
                  //               }
                  //             >
                  //               <Input
                  //                 id="redeemNumber"
                  //                 placeholder={`Enter Number`}
                  //                 onFocus={() => {
                  //                   setInputFocused("cardNumber");
                  //                   setLayoutName("numbers");
                  //                 }}
                  //                 size="large"
                  //                 onPressEnter={(e) => e.preventDefault()}
                  //                 allowClear={false}
                  //                 style={{
                  //                   borderRadius: "6px",
                  //                   padding: "8px 12px",
                  //                 }}
                  //                 maxLength={4}
                  //               />
                  //             </Form.Item>
                  //           )}
                  //         </Col>
                  //       </Row>
                  //     </Col>
                  //     <Col span={14} style={{ padding: "" }}>
                  //       <Row gutter={[8, 6]}>
                  //         <Keyboard
                  //           theme={"hg-theme-default aprvl"}
                  //           style={{ marginTop: "5px" }}
                  //           onChangeAll={(inputs) => {
                  //             setInputFields({ ...inputs });
                  //             cardPaymentForm.setFieldsValue(inputs);
                  //           }}
                  //           inputName={inputFocused}
                  //           keyboardRef={(r) => (keyboardRef.current = r)}
                  //           onKeyPress={(button) => {
                  //             const currentValue = cardPaymentForm.getFieldValue(inputFocused) || "";
                  //             if (inputFocused === "cardNumber") {
                  //               if (button.match(/^\d$/)) {
                  //                 if (currentValue.length < 4) {
                  //                   cardPaymentForm.setFieldsValue({
                  //                     cardNumber: currentValue + button,
                  //                   });
                  //                 }
                  //                 return;
                  //               } else if (button === "{backspace}") {
                  //                 cardPaymentForm.setFieldsValue({
                  //                   [inputFocused]: currentValue.slice(0, -1),
                  //                 });
                  //               }
                  //               return;
                  //             }
                  //             if (button === "{shift}" || button === "{lock}") {
                  //               handleShift();
                  //             } else if (button === "{number}" || button === "{numbers}") {
                  //               setLayoutName("numbers");
                  //             } else if (button === "{small}") {
                  //               setLayoutName("shift");
                  //             } else if (button === "{caps}") {
                  //               setLayoutName("default");
                  //             } else if (button === "{space}") {
                  //               cardPaymentForm.setFieldsValue({
                  //                 [inputFocused]: `${currentValue} `,
                  //               });
                  //             } else if (button === "{backspace}") {
                  //               cardPaymentForm.setFieldsValue({
                  //                 [inputFocused]: currentValue.slice(0, -1),
                  //               });
                  //             } else if (button !== "{enter}" && button !== "{shift}" && button !== "{caps}" && button !== "{numbers}") {
                  //               handleKeyboardInputs(button);
                  //             }
                  //           }}
                  //           layoutName={layoutName}
                  //           display={{
                  //             "{abc}": "ABC",
                  //             "{smileys}": "\uD83D\uDE03",
                  //             "{back}": "Enter",
                  //             "{numbers}": "123",
                  //             "{number}": "123",
                  //             "{bksp}": "backspace",
                  //             "{backspace}": "⌫",
                  //             "{shift}": "⇧",
                  //             "{tab}": "tab",
                  //             "{lock}": "lock",
                  //             "{enter}": "Enter",
                  //             "{space}": "Space",
                  //             "{caps}": "ABC",
                  //             "{small}": "abc",
                  //           }}
                  //           layout={{
                  //             shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                  //             numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                  //             number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                  //             default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
                  //           }}
                  //         />
                  //         <Col span={20} pull={2} push={2} style={{ padding: "3% 0", marginTop: "1%" }}>
                  //           <Button
                  //             htmlType="button"
                  //             onClick={() => {
                  //               const cardValues = cardPaymentForm.getFieldsValue();
                  //               localStorage.setItem("cardPaymentDetails", JSON.stringify(cardValues));
                  //               cardPaymentForm
                  //                 .validateFields()
                  //                 .then(() => {
                  //                   setShowCardAmountInput(true);
                  //                 })
                  //                 .catch(() => {
                  //                   message.error(`${messages.info.all_required}`);
                  //                 });
                  //             }}
                  //             style={{
                  //               backgroundColor: "#2F3856",
                  //               color: "#fff",
                  //               width: "100%",
                  //               fontSize: "1rem",
                  //               textAlign: "center",
                  //               fontWeight: "400",
                  //               borderRadius: "7px",
                  //               height: "40px",
                  //             }}
                  //           >
                  //             Submit
                  //           </Button>
                  //         </Col>
                  //       </Row>
                  //     </Col>
                  //   </Row>
                  selectedPaymentMethod?.name === "Card" ? (
                    // Card amount input
                    <Col span={24}>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "550",
                            fontSize: "0.9rem",
                          }}
                        >
                          Enter Amount
                        </label>
                        <div>
                          <Row>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "6vh",
                                margin: "0 0% 2.7% 0%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                                border: "1px solid #f0f0f0",
                              }}
                              value={currentCardInput}
                              id="sm-amount-input"
                              onChange={(e) => setCurrentCardInput(e.target.value?.replace(/[^\d.]/g, ""))}
                              onFocus={() => setFocusedInputField("currentCardInput")}
                              ref={cardInputRef}
                              placeholder="0"
                            />
                          </Row>
                          <Row style={{ padding: "0 0% 0 0.5%" }} gutter={[4, 3]}>
                            <Col span={6}>
                              <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("1")}>
                                1
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("2")}>
                                2
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("3")}>
                                3
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                className="amt-dial-btn-market"
                                id="sm-amount-buttonRemove"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => handleTotalQty("x")}
                              >
                                <img src={CancelArrow} alt="back space" width={25} height={15} />
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("4")}>
                                4
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("5")}>
                                5
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("6")}>
                                6
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                id="sm-amount-buttonClear"
                                className="amt-dial-btn-market"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => {
                                  setDenaminationsKeyboard(true);
                                  setLayoutName("numbers");
                                }}
                              >
                                1,2,3...
                              </button>
                            </Col>
                            <Col span={18}>
                              <Row gutter={[4, 3]}>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button7"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("7")}
                                  >
                                    7
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button8"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("8")}
                                  >
                                    8
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button9"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("9")}
                                  >
                                    9
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button0"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("0")}
                                  >
                                    0
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button00"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty(".")}
                                  >
                                    .
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button-clear"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("clear")}
                                  >
                                    Clear
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <button
                                id="sm-amount-buttonEnter"
                                className="amt-dial-btn-market2"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => {
                                  console.log("selectedPaymentMethod -------->", selectedPaymentMethod);
                                  // const currentInput =
                                  //   selectedPaymentMethod.name === "Cash"
                                  //     ? currentCashInput
                                  //     : selectedPaymentMethod.name === "Card"
                                  //       ? currentCardInput
                                  //       : selectedPaymentMethod.name === "UPI"
                                  //         ? currentUPIInput
                                  //         : dynamicPaymentInput;
                                  // const paymentAmount = Number.parseFloat(currentInput).toFixed(2);
                                  // if (
                                  //   selectedPaymentMethod?.name?.toLowerCase() === "card" &&
                                  //   selectedPaymentMethod?.integratedPayment &&
                                  //   posConfig?.show_card_payment_popup === "Y"
                                  // ) {
                                  //   if (isValidAmount(paymentAmount)) {
                                  //     setShowCardPaymnteModal(true);
                                  //   } else {
                                  //     message.warning("Kindly enter the amount before proceeding");
                                  //   }
                                  // } else if (
                                  //   selectedPaymentMethod?.name?.toLowerCase() === "card" &&
                                  //   !selectedPaymentMethod?.integratedPayment &&
                                  //   posConfig?.show_card_payment_popup === "Y"
                                  // ) {
                                  //   if (isValidAmount(paymentAmount)) {
                                  //     setPaymentType("manual");
                                  //     setCardPaymnetError(true);
                                  //     setShowCardPaymnteModal(true);
                                  //     return;
                                  //   } else {
                                  //     message.warning("Kindly enter the amount before proceeding");
                                  //   }
                                  // }
                                  enterTotalQtyForWallet();
                                }}
                              >
                                Enter
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  ) : selectedPaymentMethod?.name === "UPI" ? (
                    // UPI amount input
                    <Col span={24}>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "550",
                            fontSize: "0.9rem",
                          }}
                        >
                          Enter Amount
                        </label>
                        <div>
                          <Row>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "6vh",
                                margin: "0 0% 2.7% 0%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                                border: "1px solid #f0f0f0",
                              }}
                              value={currentUPIInput}
                              id="sm-amount-input"
                              onChange={(e) => setCurrentUPIInput(e.target.value?.replace(/[^\d.]/g, ""))}
                              onFocus={() => setFocusedInputField("currentUPIInput")}
                              ref={upiInputRef}
                              placeholder="0"
                            />
                          </Row>
                          <Row style={{ padding: "0 0% 0 0.5%" }} gutter={[4, 3]}>
                            <Col span={6}>
                              <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("1")}>
                                1
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("2")}>
                                2
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("3")}>
                                3
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                className="amt-dial-btn-market"
                                id="sm-amount-buttonRemove"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => handleTotalQty("x")}
                              >
                                <img src={CancelArrow} alt="back space" width={25} height={15} />
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("4")}>
                                4
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("5")}>
                                5
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("6")}>
                                6
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                id="sm-amount-buttonClear"
                                className="amt-dial-btn-market"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => {
                                  setDenaminationsKeyboard(true);
                                  setLayoutName("numbers");
                                }}
                              >
                                1,2,3...
                              </button>
                            </Col>
                            <Col span={18}>
                              <Row gutter={[8, 6]}>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button7"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("7")}
                                  >
                                    7
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button8"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("8")}
                                  >
                                    8
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button9"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("9")}
                                  >
                                    9
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button0"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("0")}
                                  >
                                    0
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button00"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty(".")}
                                  >
                                    .
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button-clear"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("clear")}
                                  >
                                    Clear
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <button
                                id="sm-amount-buttonEnter"
                                className="amt-dial-btn-market2"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => {
                                  enterTotalQtyForWallet();
                                }}
                              >
                                Enter
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  ) : selectedPaymentMethod && !["cash", "card", "upi"]?.includes(selectedPaymentMethod?.name?.toLowerCase()) ? (
                    <Col span={24}>
                      <div style={selectedPaymentMethod && selectedPaymentMethod?.isBankTransfer === "Y" ? { opacity: 0.4, userSelect: "none", pointerEvents: "none" } : {}}>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "550",
                            fontSize: "0.9rem",
                          }}
                        >
                          Enter Amount
                        </label>

                        <Input
                          size="large"
                          value={dynamicPaymentInput}
                          onChange={(e) => setDynamicPaymentInput(e.target.value.replace(/[^\d.]/g, ""))}
                          placeholder="0"
                          style={{
                            textAlign: "right",
                            fontSize: "1rem",
                            borderRadius: "6px",
                            marginBottom: "1rem",
                          }}
                        />

                        {renderGenericWalletKeypad()}
                      </div>
                    </Col>
                  ) : null}
                </Row>
              </Form>
            </Card>
          </div>
        ) : showTransactionsModal ? (
          // Transaction History Section
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                border: "1px solid #e8e8e8",
                maxHeight: "87vh",
                overflowY: "auto",
                //padding: "1rem",
              }}
            >
              {selectedCustomer[0]?.transactions && selectedCustomer[0].transactions.length > 0 ? (
                selectedCustomer[0].transactions
                  .sort((a, b) => {
                    const dateTimeA = new Date(`${a.date} ${a.time}`);
                    const dateTimeB = new Date(`${b.date} ${b.time}`);
                    return dateTimeB - dateTimeA;
                  })
                  .map((transaction, index) => (
                    <div
                      key={transaction.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0.5rem",
                        borderBottom: index < selectedCustomer[0].transactions.length - 1 ? "1px solid #f0f0f0" : "none",
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                          <span
                            style={{
                              padding: "0.3rem 1rem",
                              borderRadius: "20px",
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              backgroundColor: transaction.type === "Credit" ? "#d4edda" : "#f8d7da",
                              color: transaction.type === "Credit" ? "#155724" : "#721c24",
                              marginRight: "0.5rem",
                            }}
                          >
                            {transaction.type}
                          </span>
                          <span style={{ color: "#666", fontSize: "0.8rem" }}>
                            {transaction.date} at {transaction.time}
                          </span>
                        </div>
                        <h4 style={{ margin: "0.3rem 0", color: "#0F0718", fontSize: "1rem" }}>{transaction.description}</h4>
                        <p style={{ margin: 0, color: "#666", fontSize: "0.6rem" }}>Ref: {transaction.reference}</p>
                      </div>
                      <div style={{ textAlign: "right", minWidth: "150px" }}>
                        <h3
                          style={{
                            margin: 0,
                            fontSize: "1rem",
                            fontWeight: "bold",
                            color: transaction.type === "Credit" ? "#28a745" : "#dc3545",
                          }}
                        >
                          {transaction.type === "Credit" ? "+" : "-"}
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                          {transaction.amount.toFixed(2)}
                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                        </h3>
                        <p style={{ margin: "0.3rem 0 0 0", color: "#666", fontSize: "0.8rem" }}>
                          Balance: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                          {transaction.balance.toFixed(2)}
                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                        </p>
                      </div>
                    </div>
                  ))
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "3rem",
                    color: "#666",
                  }}
                >
                  <h3>No transactions found</h3>
                  <p>This customer hasn't made any transactions yet.</p>
                </div>
              )}
            </div>
          </div>
        ) : selectedCustomer ? (
          // Customer Details Section
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
                padding: "0.7rem",
                backgroundColor: "#fff",
                borderRadius: "10px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", height: "3vh", marginRight: "1rem" }}>
                <UserOutlined
                  style={{
                    fontSize: "1.5rem",
                    color: "#2F3856",
                    marginRight: "0.5rem",
                    padding: "0.5rem",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "50%",
                  }}
                />
                <div>
                  <h2 style={{ margin: 0, color: "#0F0718", fontSize: "1rem" }}>{selectedCustomer[0]?.name}</h2>
                  <p style={{ margin: "0.2rem 0", color: "#666", fontSize: "0.7rem" }}>
                    {selectedCustomer[0]?.phone && selectedCustomer[0]?.phone !== "N/A" ? `Mobile: ${selectedCustomer[0]?.phone} | ` : ""}ID: {selectedCustomer[0]?.id}
                  </p>
                </div>
              </div>
            </div>
            <Row gutter={[24, 24]} style={{ marginBottom: "0.5rem" }}>
              <Col span={8}>
                <Card
                  style={{
                    borderRadius: "10px",
                    textAlign: "center",
                    border: "1px solid #e8e8e8",
                    height: "20vh",
                    backgroundColor: "#fff",
                  }}
                >
                  <img src={credit || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "3vh", marginBottom: "3vh" }} alt="" />
                  <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Current Balance</h4>
                  <h2 style={{ margin: "0.5rem", color: "#28a745", fontSize: "1rem", fontWeight: "bold" }}>
                    {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
                    {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                  </h2>
                </Card>
              </Col>
              <Col span={8}>
                <Card
                  style={{
                    borderRadius: "10px",
                    textAlign: "center",
                    border: "1px solid #e8e8e8",
                    height: "20vh",
                    backgroundColor: "#fff",
                  }}
                >
                  <img src={cash || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "3vh", marginBottom: "3vh" }} alt="" />
                  <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Total Spent</h4>
                  <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                    {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {selectedCustomer[0]?.totalSpent?.toFixed(2) || "0.00"}
                    {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                  </h2>
                </Card>
              </Col>
              <Col span={8}>
                <Card
                  style={{
                    borderRadius: "10px",
                    textAlign: "center",
                    border: "1px solid #e8e8e8",
                    height: "20vh",
                    backgroundColor: "#fff",
                  }}
                >
                  <CalendarOutlined
                    style={{
                      height: "3vh",
                      fontSize: "1.7em",
                      paddingRight: "5px",
                      marginTop: "3vh",
                      marginBottom: "3vh",
                    }}
                  />
                  <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Member Since</h4>
                  <h2 style={{ margin: "0.5rem 0", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                    {selectedCustomer?.[0]?.joinDate ? formatDate(selectedCustomer[0].joinDate) : ""}
                  </h2>
                </Card>
              </Col>
            </Row>
            <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
              <Button
                type="primary"
                size="large"
                onClick={() => handleTopupWallet()}
                style={{
                  backgroundColor: "#2F3856",
                  borderColor: "#2F3856",
                  height: "45px",
                  width: "25em",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  borderRadius: "6px",
                  paddingLeft: "2rem",
                  paddingRight: "2rem",
                }}
              >
                Top-up Wallet
              </Button>
              {posConfig?.enableCustomerWalletRefund === "Y" && (
                <Button
                  size="large"
                  type="primary"
                  onClick={() => handleWalletRefund()}
                  style={{
                    backgroundColor: "#fff",
                    color: "#0F0718",
                    height: "45px",
                    width: "25em",
                    fontSize: "1.1rem",
                    fontWeight: "500",
                    borderRadius: "6px",
                    paddingLeft: "2rem",
                    paddingRight: "2rem",
                    border: "1px solid #e8e8e8",
                  }}
                >
                  Refund Wallet
                </Button>
              )}
              <Button
                size="large"
                onClick={handleViewTransactions}
                icon={<EyeOutlined />}
                style={{
                  color: "#0F0718",
                  height: "45px",
                  width: "25em",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  borderRadius: "6px",
                  paddingLeft: "2rem",
                  paddingRight: "2rem",
                }}
              >
                View Transactions
              </Button>
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <h3 style={{ color: "#0F0718", fontSize: "1.2rem", fontWeight: "600" }}>Recent Transactions</h3>
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  border: "1px solid #e8e8e8",
                  height: "38vh",
                  overflowY: "auto",
                  //padding: "1rem",
                }}
              >
                {selectedCustomer?.[0]?.transactions?.length > 0 && currenciesList?.[0] ? (
                  selectedCustomer[0].transactions
                    .sort((a, b) => {
                      const dateTimeA = new Date(`${a.date} ${a.time}`);
                      const dateTimeB = new Date(`${b.date} ${b.time}`);
                      return dateTimeB - dateTimeA;
                    })
                    .slice(0, 22)
                    .map((transaction, index) => {
                      const currency = currenciesList[0];
                      return (
                        <div
                          key={transaction.id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0.5rem",
                            borderBottom: index < 21 ? "1px solid #f0f0f0" : "none",
                            backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                              <span
                                style={{
                                  borderRadius: "20px",
                                  fontSize: "0.8rem",
                                  fontWeight: "600",
                                  backgroundColor: transaction.type === "Credit" ? "#d4edda" : "#f8d7da",
                                  color: transaction.type === "Credit" ? "#155724" : "#721c24",
                                  marginRight: "0.5rem",
                                  padding: "0.2rem 0.6rem",
                                }}
                              >
                                {transaction.type}
                              </span>
                              <span style={{ color: "#666", fontSize: "0.8rem" }}>
                                {transaction.date} at {transaction.time}
                              </span>
                            </div>
                            <h4 style={{ margin: "0.3rem 0", color: "#0F0718", fontSize: "1rem" }}>{transaction.description}</h4>
                            <p style={{ margin: 0, color: "#666", fontSize: "0.6rem" }}>Ref: {transaction.reference}</p>
                          </div>
                          <div style={{ textAlign: "right", minWidth: "120px" }}>
                            <h3
                              style={{
                                margin: 0,
                                fontSize: "1rem",
                                fontWeight: "bold",
                                color: transaction.type === "Credit" ? "#28a745" : "#dc3545",
                              }}
                            >
                              {transaction.type === "Credit" ? "+" : "-"}
                              {currency.symbolRightSide === "N" ? currency.currSymbol : ""}
                              {transaction.amount.toFixed(2)}
                              {currency.symbolRightSide === "Y" ? currency.currSymbol : ""}
                            </h3>
                            <p style={{ margin: "0.3rem 0 0 0", color: "#666", fontSize: "0.8rem" }}>
                              Bal: {currency.symbolRightSide === "N" ? currency.currSymbol : ""}
                              {transaction.balance.toFixed(2)}
                              {currency.symbolRightSide === "Y" ? currency.currSymbol : ""}
                            </p>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div style={{ textAlign: "center", padding: "1rem", color: "#666" }}>
                    <h4>No recent transactions</h4>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          // Customer Search Section
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            <Input
              placeholder="Search Customer by Name, Mobile, or ID"
              value={customerSearchValue}
              onChange={(e) => handleCustomerSearch(e.target.value)}
              prefix={<SearchOutlined />}
              style={{
                marginBottom: "1rem",
                height: "40px",
                borderRadius: "6px",
              }}
            />
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                border: "1px solid #e8e8e8",
                maxHeight: "70vh",
                overflowY: "auto",
                padding: "1rem",
              }}
            >
              {filteredCustomers.length > 0 ? (
                filteredCustomers.map((customer) => (
                  <div
                    key={customer.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "1rem",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                    }}
                    onClick={() => handleCustomerSelect(customer)}
                  >
                    <div>
                      <h4 style={{ margin: 0, color: "#0F0718", fontSize: "1rem" }}>{customer.name}</h4>
                      <p style={{ margin: "0.2rem 0", color: "#666", fontSize: "0.8rem" }}>
                        Mobile: {customer.phone} | ID: {customer.id}
                      </p>
                    </div>
                    <span style={{ color: "#28a745", fontSize: "0.9rem" }}>
                      {/* Balance: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""} */}
                    </span>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center", padding: "3rem", color: "#666" }}>
                  <h3>No customers found</h3>
                  <p>Try searching with a different keyword.</p>
                </div>
              )}
            </div>
          </div>
        )}
      </Drawer>
      <Drawer
        placement="right"
        width="62%"
        closable={false}
        footer={null}
        headerStyle={{ background: "white", padding: "22px 3vh 10px 16px", borderBottom: "none" }}
        bodyStyle={{
          padding: "16px",
          background: "#ffffff",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
        visible={isRefundWalletOpen || (!filterDrawer && localStorage?.getItem("selectedReturnType") === "STORE_CREDIT")}
        onClose={() => setIsRefundWalletOpen(false)}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span
              style={{
                fontSize: "20px",
                fontWeight: 600,
                color: "#253856",
              }}
            >
              Refund to Customer Wallet
            </span>

            {selectedReturnType !== "STORE_CREDIT" && (
              <img
                src={Close}
                onClick={() => setIsRefundWalletOpen(false)}
                style={{
                  cursor: "pointer",
                  width: 16,
                  height: 16,
                }}
              />
            )}
          </div>
        }
      >
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            paddingRight: 4,
          }}
        >
          <Card
            bordered
            style={{
              borderRadius: 8,
              marginBottom: 16,
            }}
            bodyStyle={{ padding: 16 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 12,
              }}
            >
              <span style={{ fontWeight: 600, fontSize: "16px" }}>Customer</span>
              <EditOutlined
                style={{ color: "#253856", cursor: "pointer" }}
                onClick={() => {
                  localStorage.setItem("refundCustomerEdit", "Y");
                  if (selectedReturnType !== "STORE_CREDIT") {
                    setIsRefundWalletOpen(false);
                  }
                  setTimeout(() => {
                    setDisplayCustomerSearch(true); // then open search drawer
                  }, 200);
                }}
              />
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
              <UserOutlined />
              <span style={{ fontWeight: 500 }}>{refundCustomer?.name || cart?.customer?.name || ""}</span>
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
              <PhoneOutlined />
              <span>{refundCustomer?.mobileNo || cart?.customer?.mobileNo}</span>
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 6, alignItems: "center" }}>
              <WalletOutlined />

              <span style={{ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap" }}>
                {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}

                {Number(refundCustomer?.cwrWallet?.balance_Amt ?? cart?.customer?.cwrWallet?.balance_Amt ?? 0).toFixed(2)}

                {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
              </span>
            </div>
          </Card>

          <Card
            bordered
            style={{
              borderRadius: 8,
              marginBottom: 16,
            }}
            bodyStyle={{ padding: 16 }}
          >
            <p style={{ fontWeight: 600, marginBottom: 16, fontSize: "16px" }}>Refund Summary</p>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 12,
              }}
            >
              <span>Return Amount</span>
              <span style={{ color: "#253856", fontWeight: 600 }}>
                {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                {Math.abs(cart?.total || 0).toFixed(2)}
                {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 12,
              }}
            >
              <span>Current Wallet Balance</span>
              <span>
                {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                {Number(refundCustomer ? refundCustomer?.cwrWallet?.balance_Amt : cart?.customer?.cwrWallet?.balance_Amt ? cart?.customer?.cwrWallet?.balance_Amt : 0).toFixed(2)}
                {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 12,
              }}
            >
              <span>New Wallet Balance</span>
              <span>
                {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                {(Math.abs(Number(cart?.total || 0)) + Number(refundCustomer?.cwrWallet?.balance_Amt ?? cart?.customer?.cwrWallet?.balance_Amt ?? 0)).toFixed(2)}
                {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
              </span>
            </div>
          </Card>
        </div>
        <div
          style={{
            display: "flex",
            gap: 12,
            marginTop: 24,
          }}
        >
          <Button
            style={{
              flex: 1,
              height: 40,
              borderRadius: 6,
            }}
            // disabled={selectedReturnType === "STORE_CREDIT"}
            onClick={() => {
              if (selectedReturnType === "STORE_CREDIT") {
                deleteReceipt();
                localStorage.removeItem("selectedReturnType");
                localStorage.removeItem("refundCustomerEdit");
                setSelectedReturnType(null);
                setIsRefundWalletOpen(false);
              }
              setIsRefundWalletOpen(false);
            }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            style={{
              flex: 1,
              height: 40,
              borderRadius: 6,
              background: "#253856",
              borderColor: "#16a34a",
            }}
            onClick={async () => {
              const refundAmount = Math.abs(cart.total);

              if (!selectedPaymentMethod?.name) {
                message.warning("Select payment method");
                return;
              }

              // add wallet payment like normal
              await requestPayment(selectedPaymentMethod, refundAmount.toFixed(2));
              // const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj"));
              // if (!exchangeCartObj) {
              //   localStorage.removeItem("selectedReturnType");
              // }
              setIsRefundWalletOpen(false);
              // close drawer

              // small delay so cart updates
              // setTimeout(() => {
              //   processOrder(
              //     "refund",
              //     pendingRefundCustomer?.customer?.cwrCustomerId
              //   );
              // }, 150);
            }}
          >
            Confirm Refund
          </Button>
        </div>
      </Drawer>

      <Modal visible={showWalletOtpModal} footer={null} closable={false} centered bodyStyle={{ textAlign: "center", padding: "40px 24px" }}>
        <Title level={4}>Verify OTP for Wallet Redemption</Title>

        <p style={{ marginBottom: 20 }}>Redeeming wallet amount: {walletOtpAmount}</p>

        <Row justify="center" gutter={8} style={{ marginBottom: 28 }}>
          {walletOtp.map((digit, idx) => (
            <Col key={idx}>
              <Input
                maxLength={1}
                value={digit}
                ref={(el) => (walletOtpInputsRef.current[idx] = el)}
                onChange={(e) => {
                  const newOtp = [...walletOtp];
                  newOtp[idx] = e.target.value;
                  setWalletOtp(newOtp);

                  if (e.target.value && idx < 5) {
                    walletOtpInputsRef.current[idx + 1]?.focus();
                  }
                }}
                style={{
                  width: 50,
                  height: 50,
                  textAlign: "center",
                  fontSize: 20,
                }}
              />
            </Col>
          ))}
        </Row>

        {walletOtpError && <Alert type="error" message="Invalid OTP" showIcon style={{ marginBottom: 20 }} />}

        <Row justify="center" gutter={16}>
          <Col>
            <Button
              onClick={() => {
                setShowWalletOtpModal(false);
                setWalletOtp(Array(6).fill(""));
                setWalletOtpError(false);
              }}
            >
              Cancel
            </Button>
          </Col>

          <Col>
            <Button style={{ color: "white", background: "#253856", borderColor: "#253856" }} type="primary" onClick={handleWalletOtpVerify} disabled={walletOtp.includes("")}>
              Verify OTP
            </Button>
          </Col>
        </Row>
      </Modal>

      <Modal
        visible={showReturnOptions}
        closable={true}
        footer={null}
        centered
        width="35%"
        onCancel={() => {
          setShowReturnOptions(false);
          const cartData = JSON.parse(localStorage.getItem("cartObj")) || {};
          if (cartData?.isReturn === true) {
            delete cartData.isReturn;
          }
          if (cartData?.isBlindReceipt === true) {
            delete cartData.isBlindReceipt;
          }
          setCart(cartData);
          localStorage.setItem("cartObj", JSON.stringify(cartData));
          // setSelectedReturnType(null);
        }}
        bodyStyle={{
          padding: "20px",
          // backgroundColor: "#F3F4F9",
          backgroundColor: "#white",
          borderRadius: "8px",
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: "16px", fontWeight: 600 }}>How would you like to return?</div>
          <div style={{ fontSize: "13px", color: "#6B7280" }}>Choose the return option that works best for you</div>
        </div>

        {renderReturnOptions()}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            marginTop: 16,
          }}
        >
          <Button
            onClick={() => {
              setShowReturnOptions(false);
              setSelectedReturnType(null);
              const cartData = JSON.parse(localStorage.getItem("cartObj")) || {};
              if (cartData?.isReturn === true) {
                delete cartData.isReturn;
              }
              if (cartData?.isBlindReceipt === true) {
                delete cartData.isBlindReceipt;
              }
              setCart(cartData);
              localStorage.setItem("cartObj", JSON.stringify(cartData));
            }}
            style={{ borderColor: "#92909880", borderRadius: "5px", height: "6vh" }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            disabled={!selectedReturnType}
            onClick={async () => {
              console.log("Selected:", selectedReturnType);
              const cartObj = JSON.parse(localStorage.getItem("cartObj"));
              if (cartObj?.isBlindReceipt === true && cartObj?.isReturn === true) {
                setFilterDrawer(true);
                localStorage.setItem("returnThisReceipt", true);
                if (selectedReturnType === "EXCHANGE") {
                  const exchangeCartObj = createExchangeCartObj();
                  localStorage.setItem("exchangeCartObj", JSON.stringify(exchangeCartObj));
                  localStorage.setItem("selectedReturnType", selectedReturnType);
                }
                setShowReturnOptions(false);
              } else {
                if (selectedReturnType === "REFUND") {
                  setLoading(true);
                  setIsPurchaseReturn(false);
                  setStartRowData({ startRow: "0", endRow: "10" });
                  setIsInputFocused(true);
                  await addSelectedReturnProductsToCart();
                  setShowReturnOptions(false);
                } else if (selectedReturnType === "STORE_CREDIT") {
                  setIsPurchaseReturn(false);
                  localStorage.setItem("selectedReturnType", selectedReturnType);
                  const updatedCart = await addSelectedReturnProductsToCart();
                  const walletPayment = tillDataPaymentMethods.find((pm) => pm.isWallet === "Y");
                  if (walletPayment && updatedCart?.customer?.cwrWallet?.wallet_Id) {
                    setSelectedPaymentMethod(walletPayment);
                  }
                  setIsRefundWalletOpen(true);
                } else if (selectedReturnType === "EXCHANGE") {
                  setIsPurchaseReturn(false);
                  const exchangeCartObj = createExchangeCartObj();
                  localStorage.setItem("exchangeCartObj", JSON.stringify(exchangeCartObj));
                  await addSelectedReturnProductsToCart();
                }
                localStorage.setItem("selectedReturnType", selectedReturnType);
                setShowReturnOptions(false);
              }
            }}
            style={{
              backgroundColor: "#2F3856",
              borderColor: "#2F3856",
              borderRadius: "5px",
              color: "white",
              height: "6vh",
              opacity: !selectedReturnType ? 0.45 : 1,
            }}
          >
            Continue
          </Button>
        </div>
      </Modal>
      {walletPopup()}
      {/* Customer Wallet Drawer End */}

      {/* Gift Card Drawer */}
      {giftCardPopup()}
      {/* Gift Card Drawer End */}

      {/* Bank Transfer Drawer */}
      {bankTransferPopup()}
      {/* Bank Transfer Drawer End */}
    </Fragment>
  );
};

export default PointOfSuperMarketModals;
